import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import workSpaceCss from "../../css/workSpaceOverView.module.css";
import FSSideMenu from "../../components/standalonefs/FSSideMenu";
import FSTopBar from "../../components/standalonefs/FSTopBar";
import CashflowWorkings from "../libraries/CashflowWorkings";
import SidePanel from "../libraries/SidePanel.jsx";
import AdjustmentLog from "./AdjustmentLog";
import AddNewAdjustment from "./AddNewAdjustment";
import swal from "sweetalert";
import {
  deletePopulateFSApiHandler,
  getPopulateFSDetailsApiHandler,
  updatePopulateFSApiHandler,
  replaceNotesTableApiHandler,
  addNotesSubgroupApiHandler,
  replaceSocieApiHandler,
  addCashflowRowApiHandler,
  rearrangeCashflowRowApiHandler,
  deletePopulateFSSectionApiHandler,
  rearrangeFSSectionApiHandler,
  restorePopulateFSDeletedItemsApiHandler,
  permanentDeletePopulateFSItemsApiHandler,
  addFSSectionApiHandler,
  updateFSSectionApiHandler,
  deletePopulateFSGroupingItemApiHandler,
  setStandaloneSocieCellFormula,
  setStandaloneDisclosureCellFormula,
  deleteStandaloneDisclosureCellFormula,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import DeletePopup from "../../elements/DeletePopup";
import RestorePopup from "../../elements/RestorePopup";
import SuccessPopup from "../../elements/SuccessPopup";
import { motion } from "framer-motion";
import commoncss from "../../css/common.module.css";
import bookclosurecss from "../../css/bookclosure.module.css";
import QuillReactEditor from "../../components/QuillReactEditor";
import FSTable from "./FSTable";
import ViewRPTTransactions from "./ViewRPTTransactions";
import { Spinner } from "react-bootstrap";
import { ReactComponent as CirclePlus } from "../../assets/icons/circlePlus.svg";
import { ReactComponent as AddEditor } from "../../assets/icons/addEditor.svg";
import { ReactComponent as AddTable } from "../../assets/icons/addTable.svg";
import { ReactComponent as RestoreIcon } from "../../assets/icons/repeatIcon.svg";
import { ReactComponent as EmptyIcon } from "../../assets/icons/Empty.svg";
import { ReactComponent as DelIcon } from "../../assets/icons/delete_red.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import StandaloneBin from "../../components/standalonefs/Bin/StandaloneBin";


import TemplateTableGenerator from "../libraries/TemplateTableGenerator";
import MenuIcon from "../../assets/icons/Menu.png";


const StandaloneFinancialStatement = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [showAddAdjustment, setShowAddAdjustment] = useState(false);
  const [showBin, setShowBin] = useState(false);
  const [activeBinTab, setActiveBinTab] = useState("Level 1");
  const [activeBinSection, setActiveBinSection] = useState("Balance Sheet");
  const [selectedBinItems, setSelectedBinItems] = useState([]);
  const [deletedItems, setDeletedItems] = useState([]);

  useEffect(() => {
    setSelectedBinItems([]);
  }, [activeBinSection, activeBinTab]);

  const binSections = ["Balance Sheet", "P&L Statement", "General Notes", "Balance Sheet Notes", "P&L Statement Notes", "Disclosures"];
  const [activeCat, setActiveCat] = useState(
    localStorage.getItem("activeCat") || "BS"
  );
  const [isNotes, setIsNotes] = useState(false);
  const [loadData, setLoadData] = useState([]);
  const [notesId, setNotesId] = useState(null);
  const [redirectNote, setRedirectNote] = useState(null);
  const [subMenuId, setSubMenuId] = useState(null);
  const [subgroupId, setSubGroupId] = useState(null);
  const [columns, setColumns] = useState([]);
  const [subMenu, setSubMenu] = useState(null);
  const [rows, setRows] = useState([]);
  const [notesData, setNotesData] = useState(null);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const [showCashflowWorkings, setShowCashflowWorkings] = useState(
    localStorage.getItem("showCashflowWorkings") === "true"
  );
  const [fsNotesResponseData, setFsNotesResponseData] = useState(null);
  const [redirectSearch, setRedirectSearch] = useState(null);
  const [targetSubGroupId, setTargetSubGroupId] = useState(null);

  const [bottomBlocks, setBottomBlocks] = useState([]);
  const [isAddingTable, setIsAddingTable] = useState(false);
  const [forceOpenTableId, setForceOpenTableId] = useState(null);
  const [isSavingTable, setIsSavingTable] = useState(true);
  const bottomBlocksRef = useRef([]);
  const standaloneTableSaveTimeoutRef = useRef({});
  const creatingBlockRef = useRef({});
  const blockSubgroupRefs = useRef({});
  const skipStandaloneTableSaveOnceRef = useRef({});
  
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [restoreConfirm, setRestoreConfirm] = useState(null);
  
  const [currentYearLabel, setCurrentYearLabel] = useState("Current Year");
  const [previousYearLabel, setPreviousYearLabel] = useState("Previous Year");

  const genId = () => Math.random().toString(36).slice(2);
  const hiddenStandaloneTableKeys = ["isSubRow", "isNewRow", "isNew"];

  const getVisibleStandaloneTableRows = (tableRows = []) =>
    (Array.isArray(tableRows) ? tableRows : []).map((row) => {
      const nextRow = { ...(row || {}) };
      hiddenStandaloneTableKeys.forEach((key) => {
        delete nextRow[key];
      });
      return nextRow;
    });

  const hasVisibleStandaloneTableValues = (tableRows = []) =>
    getVisibleStandaloneTableRows(tableRows).some((row) =>
      Object.values(row || {}).some(
        (value) =>
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ""
      )
    );

  useEffect(() => {
    bottomBlocksRef.current = bottomBlocks;
  }, [bottomBlocks]);

  const checkUnsaved = () => {
    if (isAddingTable || bottomBlocks.some((b) => b.isTemp)) {
      swal("Warning", "Save the table first", "warning");
      return true;
    }
    return false;
  };

  const handleSetActiveCat = (val) => {
    if (checkUnsaved()) return;
    setActiveCat(val);
  };

  const handleSetSubMenuId = (val) => {
    if (checkUnsaved()) return;
    setSubMenuId(val);
  };

  const handleAddParagraph = async () => {
    if (checkUnsaved()) return;
  try {
    const catToUse = (activeCat === "cashflow" && showCashflowWorkings) ? "cashflowWorkings" : activeCat;
    let activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;
    
    if (!activeGroupId && catToUse === "cashflowWorkings") {
      const tempRes = await getPopulateFSDetailsApiHandler({ projectID: project_id, category: "cashflowWorkings" });
      if (tempRes?.data?.success && tempRes?.data?.data?.length > 0) {
        activeGroupId = tempRes.data.data[0]._id;
      }
    }

    if (!activeGroupId) {
      swal("Error", "No group ID found. Please try refreshing the page.", "error");
      return;
    }

    const params = {
      projectID: project_id,
      category: catToUse,
      groupID: activeGroupId,
    };

    const payload = {
      dataType: "text",
      textRaw: "<p></p>",
      textPlain: ""
    };

    const response = await addNotesSubgroupApiHandler(
      params,
      payload
    );

    if (response?.data?.success) {
      await getPopulateFSNotes(catToUse);
    }
  } catch (err) {
  console.log("STATUS", err.response?.status);
  console.log("DATA", err.response?.data);
  console.log("FULL ERROR", err);

  swal("Error", "Unable to create editor", "error");
}
};

  const handleTableBlockChange = async (blockId, next) => {
    try {
      if (standaloneTableSaveTimeoutRef.current[blockId]) {
        clearTimeout(standaloneTableSaveTimeoutRef.current[blockId]);
      }
      skipStandaloneTableSaveOnceRef.current[blockId] = true;
      
      setIsSavingTable(true);
      const catToUse = (activeCat === "cashflow" && showCashflowWorkings) ? "cashflowWorkings" : activeCat;
      let activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;
      
      if (!activeGroupId && catToUse === "cashflowWorkings") {
        const tempRes = await getPopulateFSDetailsApiHandler({ projectID: project_id, category: "cashflowWorkings" });
        if (tempRes?.data?.success && tempRes?.data?.data?.length > 0) {
          activeGroupId = tempRes.data.data[0]._id;
        }
      }

      if (!activeGroupId) {
        swal("Error", "No group ID found. Please try refreshing the page.", "error");
        setIsSavingTable(false);
        return;
      }

      const params = {
        projectID: project_id,
        category: catToUse,
        groupID: activeGroupId,
      };
      
      // Format table columns with proper structure
      const tableColumnData = (next.tableColumn || []).map((col) => ({
        name: col.name || ""
      }));
      
      const finalTableColumn = tableColumnData.length > 0
        ? tableColumnData
        : [{ name: "Particulars" }, { name: "Current Year" }, { name: "Previous Year" }];

      const payload = {
        dataType: "table",
        tableTitle: next.tableTitle || "New Table",
        tableType: "default",
        tableColumn: finalTableColumn,
        // tableRow: next.tableRow,
        // hasCellData: next.hasCellData,
      };
      
      const response = await addNotesSubgroupApiHandler(params, payload);
      if (response?.data?.success) {
        const newSubgroup = response.data.data;
        
        const tableDataToSave = next.tableData || next.table || [];
        
        // Map frontend column names to strict backend schema fields
        const fieldMapping = {};
        finalTableColumn.forEach((col, idx) => {
          let mappedField = `column_${idx}`;
          if (col.name?.toLowerCase() === "particulars") mappedField = "particular";
          if (col.name?.toLowerCase() === "current year") mappedField = "currentYear";
          if (col.name?.toLowerCase() === "previous year") mappedField = "previousYear";
          fieldMapping[col.name] = mappedField;
        });

        const cleanRows = tableDataToSave.map(({ _id, id, isNewRow, isSubRow, lineType, rowID, cashflowID, subNoteID, ...rest }) => {
          const newRow = { lineType: lineType || "line item" };
          Object.entries(rest).forEach(([key, val]) => {
            const mappedKey = fieldMapping[key] || key;
            newRow[mappedKey] = val;
          });
          return newRow;
        });
        
        if (cleanRows.length > 0) {
          const updateParams = { ...params, subgroupID: newSubgroup._id || newSubgroup.id };
          const updatePayload = { table: cleanRows };
          const useReplaceApi = ["BS notes", "PL notes", "general notes", "disclosure", "cashflowWorkings"].includes(catToUse);
          if (useReplaceApi) {
            await replaceNotesTableApiHandler(updateParams, updatePayload);
          } else {
            await updatePopulateFSApiHandler(updateParams, updatePayload);
          }
        }
        await getPopulateFSNotes(catToUse);
        setBottomBlocks((prev) => prev.filter((b) => b.id !== blockId));
        swal({
          title: "Success",
          text: "Table added successfully",
          icon: "success",
          button: "OK",
          timer: 1500
        });
      } else {
        swal("Error", response?.data?.message || "Failed to save table", "error");
      }
    } catch (err) {
      console.error("Error adding table:", err?.response || err);
      const errorMsg = err?.response?.data?.message || "Failed to add table. Please try again.";
      swal("Error", errorMsg, "error");
    } finally {
      setIsSavingTable(false);
    }
  };

  const handleAddTableWithoutModal = () => {
    if (checkUnsaved()) return;
    const newTableId = genId();
    setBottomBlocks((prev) => [
      {
        id: newTableId,
        type: "table",
        tableTitle: "New Table",
        tableColumn: [],
        tableRow: [],
        table: [],
        tableData: [],
        isTemp: true,
        isSaved: false,
        forceOpen: true,
      },
      ...prev,
    ]);
  };

  const getStandaloneTableRowsForSave = (tableRows = []) =>
    (Array.isArray(tableRows) ? tableRows : []).map((row) => {
      const nextRow = { ...(row || {}) };
      delete nextRow.isSubRow;
      delete nextRow.isNewRow;
      delete nextRow.isNew;
      return nextRow;
    });

  const sanitizeStandaloneTableRows = (tableRows = []) =>
    getStandaloneTableRowsForSave(tableRows).filter((row) =>
      Object.entries(row || {}).some(([key, value]) => {
        if (["_id", "id", "lineType", "rowID", "cashflowID", "subNoteID"].includes(key)) {
          return false;
        }
        return (
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ""
        );
      })
    );

  const hasStandaloneTableValues = (tableRows = []) =>
    sanitizeStandaloneTableRows(tableRows).some((row) =>
      Object.entries(row || {}).some(([key, value]) => {
        if (["_id", "id", "lineType", "rowID", "cashflowID", "subNoteID"].includes(key)) {
          return false;
        }
        return (
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ""
        );
      })
    );

  const queueStandaloneTableSave = (blockId) => {
    const existingTimeout = standaloneTableSaveTimeoutRef.current[blockId];
    if (existingTimeout) {
      clearTimeout(existingTimeout);
    }

    standaloneTableSaveTimeoutRef.current[blockId] = setTimeout(() => {
      const latestTable = bottomBlocksRef.current.find(
        (block) => block.id === blockId
      );
      if (!latestTable || latestTable.isTemp) return;

      if (!latestTable || latestTable.isCreating || creatingBlockRef.current[blockId]) {
        if (!latestTable) return;
        // If it's currently creating, check back again in 500ms so we don't lose these keystrokes
        if (creatingBlockRef.current[blockId]) {
          standaloneTableSaveTimeoutRef.current[blockId] = setTimeout(() => {
            queueStandaloneTableSave(blockId);
          }, 500);
        }
        return;
      }

      if (skipStandaloneTableSaveOnceRef.current[blockId]) {
        skipStandaloneTableSaveOnceRef.current[blockId] = false;
        return;
      }

      const sanitizedRows = sanitizeStandaloneTableRows(
        latestTable.tableData || latestTable.table || []
      );
      const currentSerialized = JSON.stringify(sanitizedRows);
      const lastSavedSerialized = JSON.stringify(
        latestTable.lastSavedTableData || []
      );

      if (currentSerialized === lastSavedSerialized) {
        return;
      }

      const hasEnteredValues = sanitizedRows.length > 0;

      if (hasEnteredValues) {
        saveTableToApi(blockId, latestTable);
      }
    }, 1500);
  };

  const createStandaloneTableStructure = async (blockId, tableData) => {
    const catToUse =
      activeCat === "cashflow" && showCashflowWorkings
        ? "cashflowWorkings"
        : activeCat;
    let activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;

    if (!activeGroupId && catToUse === "cashflowWorkings") {
      const tempRes = await getPopulateFSDetailsApiHandler({
        projectID: project_id,
        category: "cashflowWorkings",
      });
      if (tempRes?.data?.success && tempRes?.data?.data?.length > 0) {
        activeGroupId = tempRes.data.data[0]._id;
      }
    }

    if (!activeGroupId) {
      console.error("No group ID found");
      return null;
    }

    const params = {
      projectID: project_id,
      category: catToUse,
      groupID: activeGroupId,
    };

    const rowsToSave = sanitizeStandaloneTableRows(
      tableData.tableData || tableData.table || []
    );

    const payload = {
      dataType: "table",
      tableTitle: tableData.tableTitle || "New Table",
      tableType: "default",
      tableColumn: tableData.tableColumn || [],
      table: rowsToSave,
    };

    setBottomBlocks((prev) =>
      prev.map((b) => (b.id === blockId ? { ...b, isCreating: true } : b))
    );

    creatingBlockRef.current[blockId] = true;

    try {
      const response = await addNotesSubgroupApiHandler(params, payload);
      if (!response?.data?.success) {
        return null;
      }

      const responseData = response.data.data;
      const newSubgroup = Array.isArray(responseData) 
        ? responseData[responseData.length - 1] 
        : responseData;
      const subgroupID = newSubgroup?._id || newSubgroup?.id;

      setBottomBlocks((prev) =>
        prev.filter((b) => b.id !== blockId)
      );

      await getPopulateFSNotes(catToUse);
      blockSubgroupRefs.current[blockId] = subgroupID;
      creatingBlockRef.current[blockId] = false;
      return subgroupID;
    } catch (err) {
      console.error("Error creating standalone table structure:", err);
      setBottomBlocks((prev) =>
        prev.map((b) => (b.id === blockId ? { ...b, isCreating: false } : b))
      );
      creatingBlockRef.current[blockId] = false;
      return null;
    }
  };

  const isStandaloneBlankRow = (row = {}) =>
    !Object.entries(row || {}).some(([key, value]) => {
      if (["_id", "id", "lineType", "rowID", "cashflowID", "subNoteID"].includes(key)) {
        return false;
      }
      return (
        value !== null &&
        value !== undefined &&
        String(value).trim() !== ""
      );
    });

  const saveTableToApi = async (blockId, tableData) => {
    try {
      setIsSavingTable(true);
      const catToUse = (activeCat === "cashflow" && showCashflowWorkings) ? "cashflowWorkings" : activeCat;
      let activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;

      if (!activeGroupId && catToUse === "cashflowWorkings") {
        const tempRes = await getPopulateFSDetailsApiHandler({ projectID: project_id, category: "cashflowWorkings" });
        if (tempRes?.data?.success && tempRes?.data?.data?.length > 0) {
          activeGroupId = tempRes.data.data[0]._id;
        }
      }

      if (!activeGroupId) {
        console.error("No group ID found");
        return false;
      }

      const params = {
        projectID: project_id,
        category: catToUse,
        groupID: activeGroupId,
      };

      const payload = {
        dataType: "table",
        tableTitle: tableData.tableTitle || "New Table",
        tableType: "default",
        tableColumn: tableData.tableColumn || [],
      };

      let subgroupID = tableData.subgroupID || blockSubgroupRefs.current[blockId];

      if (!subgroupID) {
        subgroupID = await createStandaloneTableStructure(blockId, tableData);
        if (!subgroupID) {
          return false;
        }
      }

      const rowsToSave = sanitizeStandaloneTableRows(
        tableData.tableData || tableData.table || []
      );

      if (rowsToSave.length > 0) {
        const updateParams = { ...params, subgroupID };
        const updatePayload = { table: rowsToSave };
        const useReplaceApi = ["BS notes", "PL notes", "general notes", "disclosure", "cashflowWorkings"].includes(catToUse);
        if (useReplaceApi) {
          await replaceNotesTableApiHandler(updateParams, updatePayload);
        } else {
          await updatePopulateFSApiHandler(updateParams, updatePayload);
        }
      }

      setBottomBlocks((prev) =>
        prev.filter((b) => b.id !== blockId)
      );
        return true;
    } catch (err) {
      console.error("Error saving table:", err);
      return false;
    } finally {
      setIsSavingTable(false);
    }
  };

  const removeItem = (id) => {
    setBottomBlocks((prev) => prev.filter((b) => b.id !== id));
  };



  const updateEditorContent = (id, newContent) => {
    setBottomBlocks((prev) =>
      prev.map((b) =>
        b.id === id ? { ...b, text: [{ content: newContent }] } : b
      )
    );
  };

  const updateTableItem = (id, patch) => {
    setBottomBlocks((prev) =>
      prev.map((b) => (b.id === id ? { ...b, ...patch } : b))
    );
  };

  const onDragEndItems = (result) => {
    if (!result.destination) return;
    const items = Array.from(bottomBlocks);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setBottomBlocks(items);
  };
  const [loadingCount, setLoadingCount] = useState(0);
  const isLoading = loadingCount > 0;

  const [showLinkPanel, setShowLinkPanel] = useState(false);
  const [selectedCell, setSelectedCell] = useState(null);
  const [activeCellKey, setActiveCellKey] = useState(null);
  const [panelDataID, setPanelDataID] = useState(null);

  const project_id = sessionStorage.getItem("project_id") || localStorage.getItem("project_id");

  const handleCellLinkClick = (row, col, tableID, isLinked) => {
    const normalize = (v) => String(v || "").trim().toLowerCase();

    // SOCIE rows carry the visible label in `particular`; `Particulars` is a
    // numeric data column and can be the string "0" after table formatting.
    const rowNameCandidates = [
      row.particular,
      row.particulars,
      row.Particular,
      row.Particulars,
      row.row_header,
      row.rowHeader,
      row.name,
      row.description,
    ];
    const rowIdentifier = rowNameCandidates.find(
      (candidate) => typeof candidate === "string" && candidate.trim() !== ""
    ) || "";
    const rowName = normalize(rowIdentifier);
    const colName = col.field;
    const currentRowId = row.rowId || row._id || row.id || tableID;
    const finalRowName = String(rowIdentifier || currentRowId || "");
    
    const key = `${subMenuId || ''}-${currentRowId || ''}-${rowName}-${colName}`;
    
    setSelectedCell({
      row: finalRowName,
      rowId: currentRowId,
      col: colName,
      originalFormulaRow: isLinked?.row || isLinked?.rowID || isLinked?.rowId || null,
      initialFormula: isLinked || null,
    });
    setPanelDataID(activeCat === "disclosure" ? tableID : currentRowId);
    setActiveCellKey(key);
    setShowLinkPanel(true);
  };

  const filteredColumns = columns.filter(
    c => c.field !== "cellFormulas"
  );

  const getAllCellFormulas = (data) => {
    let formulas = [];
    const walk = (node) => {
      if (node.cellFormulas && Array.isArray(node.cellFormulas)) {
         formulas = formulas.concat(
           node.cellFormulas.map((formula) => ({
             ...formula,
             rowId:
               activeCat === "socie"
                 ? formula.rowId || formula.rowID || node._id || node.id
                 : formula.rowId || formula.rowID,
           }))
         );
      }
      if (node.subgroup && node.subgroup.length) {
        node.subgroup.forEach(walk);
      }
      if (node.data && node.data.length) {
        node.data.forEach(walk);
      }
    };
    if (Array.isArray(data)) {
       data.forEach(walk);
    } else if (data) {
       walk(data);
    }
    return formulas;
  };

  useEffect(() => {
    localStorage.setItem("activeCat", activeCat);
  }, [activeCat]);

  useEffect(() => {
    localStorage.setItem("showCashflowWorkings", showCashflowWorkings ? "true" : "false");
  }, [showCashflowWorkings]);

  // ── Sync rows from the correct source depending on category ───────────────
  useEffect(() => {
    if (activeCat === "BS" || activeCat === "PL") {
      const result = transformData(loadData ?? []);
      setRows(result ?? []);
    } else if (["general notes", "BS notes", "PL notes", "disclosure"].includes(activeCat)) {
      setRows(fsNotesResponseData ?? []);
    } else {
      setRows(loadData ?? []);
    }
  }, [loadData, fsNotesResponseData, activeCat]);

  useEffect(() => {
  if (activeCat !== "cashflow") {
    setShowCashflowWorkings(false);
    setShowAdjustmentLog(false);
  }
  setShowBin(false);
}, [activeCat]);


  // ── Set columns / isNotes / subMenu based on activeCat and rows ───────────
  useEffect(() => {
    setColumns([]);

    // BS / PL
    if (activeCat === "BS" || activeCat === "PL") {
      setIsNotes(false);
      setSubMenu(null);
      setColumns([
        {
          label: "Particular",
          field: "particular",
          align: "left",
          editable: false,
          width: "70%",
        },
        {
          label: "Notes",
          field: "notes",
          align: "center",
          editable: false,
          type: "redirect",
          width: 100,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          label: currentYearLabel || "Current Year",
          field: "currentYear",
          align: "right",
          editable: false,
          type: "number",
          width: 200,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          label: previousYearLabel || "Previous Year",
          field: "previousYear",
          align: "right",
          editable: false,
          type: "number",
          width: 200,
          minWidth: 200,
          maxWidth: 200,
        },
      ]);
      return;
    }

    // SOCIE / Cashflow
    if (["socie", "cashflow"].includes(activeCat)) {
      setIsNotes(false);
      setSubMenu(null);

      if (rows.length > 0) {
        const catRows = Object.keys(rows[0] || {});

        // Reorder: Put Years at the end and remove baseCurrentYear
        const sortedRows = [
          ...catRows.filter((c) => {
            const lower = String(c).toLowerCase().trim();
            return !["_id", "linetype", "line type", "line-type", "lineitem", "reference", "references", "isbold", "formulatype", "currentyear", "previousyear", "basecurrentyear", "derivedfromworkings", "groupingid", "grouping id"].includes(lower);
          }),
          ...catRows
            .filter((c) =>
              ["currentYear", "previousYear"].includes(c)
            )
            .sort((a, b) => {
              if (a === "currentYear") return -1;
              return 1;
            }),
        ];

        const tableCols = sortedRows.map((item) => {
          let alignValue = "left";
          const lowerItem = item.toLowerCase();

          if (lowerItem === "currentyear" || lowerItem === "previousyear") {
            alignValue = "right";
          }

          if (activeCat === "socie" && lowerItem !== "particular") {
            alignValue = "right";
          }

          let colWidth = 300;
          let minColWidth = 300;
          let maxColWidth = undefined;

          if (lowerItem === "currentyear" || lowerItem === "previousyear") {
            colWidth = 200;
            minColWidth = 200;
            maxColWidth = 200;
          } else if (lowerItem === "particular") {
            colWidth = "70%";
            minColWidth = 500;
          } else if (activeCat === "socie") {
            colWidth = 220;
            minColWidth = 220;
            maxColWidth = 220;
          }

          let labelVal = item;
          if (lowerItem === "currentyear") labelVal = currentYearLabel || "Current Year";
          else if (lowerItem === "previousyear") labelVal = previousYearLabel || "Previous Year";

          return {
            label: labelVal,
            field: item,
            align: alignValue,
            editable: (activeCat === "cashflow" && (lowerItem === "currentyear" || lowerItem === "previousyear")) ? false : true,
            type: "text",
            width: colWidth,
            minWidth: minColWidth,
            maxWidth: maxColWidth,
            headerStyle: {
              width: colWidth,
              minWidth: minColWidth,
              maxWidth: maxColWidth,
              textAlign: alignValue,
              whiteSpace: activeCat === "socie" && lowerItem !== "particular" ? "normal" : "nowrap",
            },
          };
        });

        setColumns(tableCols);
      }
      return;
    }

    // Notes categories
    if (
      ["general notes", "BS notes", "PL notes", "disclosure", "checklist"].includes(activeCat)
    ) {
      setIsNotes(true);
      const submenuArray = rows.map((item) => ({
        label: item.particular,
        value: item._id,
        subGroup: item.subgroup,
      }));

      setSubMenu({
        category: activeCat,
        submenu: submenuArray,
      });

      // Auto-select first item if none selected
      if (submenuArray.length > 0 && !subMenuId) {
        setSubMenuId(submenuArray[0].value);
      }
      
      setColumns([]);
      return;
    }

    setIsNotes(false);
    setSubMenu(null);
    setColumns([]);
  }, [activeCat, rows, subMenuId, currentYearLabel, previousYearLabel]);


  const handleRowsChange = (updatedRows, tableId) => {
    if (isNotes) {
      const params = {
        category: activeCat,
        projectID: project_id,
        groupID: subMenuId,
        subgroupID: tableId,
      };

      // Strip internal fields before sending to API
      const cleanRows = updatedRows.map(({ isNewRow, ...rest }) => rest);
      const payload = {
        table: cleanRows,
      };

      // Use replaceNotesTable for categories that support add/delete/rearrange
     const useReplaceApi = [
        "BS notes",
        "PL notes",
        "general notes",
        "disclosure",
        "cashflowWorkings"
      ].includes(activeCat);

      if (activeCat === "disclosure") {
        const currentGroup = (fsNotesResponseData || []).find((g) => g._id === subMenuId);
        const currentSubgroup = (currentGroup?.subgroup || currentGroup?.subGroup || []).find((sg) => (sg._id || sg.id) === tableId);
        const prevTable = currentSubgroup?.table || [];
        const cellFormulas = currentSubgroup?.cellFormulas || [];

        if (cellFormulas.length > 0 && Array.isArray(prevTable)) {
          const cleanKey = (v) => String(v || "").toLowerCase().replace(/[^a-z0-9]/g, "");
          const renamedRows = [];
          (cleanRows || []).forEach((newRow, idx) => {
            const prevRow = (newRow._id && prevTable.find((r) => r._id === newRow._id)) || prevTable[idx];
            if (prevRow) {
              const oldParticular = String(prevRow.particular || "").trim();
              const newParticular = String(newRow.particular || "").trim();
              if (oldParticular && newParticular && oldParticular !== newParticular) {
                renamedRows.push({ oldParticular, newParticular });
              }
            }
          });

          if (renamedRows.length > 0) {
            renamedRows.forEach(async ({ oldParticular, newParticular }) => {
              const cleanOld = cleanKey(oldParticular);
              const matchingFormulas = cellFormulas.filter((f) => {
                const fRow = String(f?.row || "").trim().toLowerCase();
                return fRow === oldParticular.toLowerCase() || (cleanOld && cleanKey(fRow) === cleanOld);
              });

              for (const f of matchingFormulas) {
                try {
                  await setStandaloneDisclosureCellFormula(
                    { projectID: project_id, disclosureID: subMenuId, subgroupID: tableId },
                    {
                      row: newParticular,
                      col: f.col,
                      type: f.type || "formula",
                      terms: f.terms,
                      link: f.link,
                      isBold: f.isBold,
                      formulaType: f.formulaType,
                    }
                  );
                  if (cleanKey(f.row) !== cleanKey(newParticular) || f.row !== newParticular) {
                    await deleteStandaloneDisclosureCellFormula({
                      projectID: project_id,
                      disclosureID: subMenuId,
                      subgroupID: tableId,
                      row: f.row,
                      col: f.col,
                    });
                  }
                } catch (e) {
                  console.warn("Failed to migrate disclosure formula on row rename", e);
                }
              }
            });
          }
        }
      }

      const apiCall = useReplaceApi
        ? replaceNotesTableApiHandler(params, payload)
        : updatePopulateFSApiHandler(params, payload);

      apiCall
        .then((response) => {
          if (response?.data?.success === true) {
            if (useReplaceApi) {
              // Refresh to get server-assigned IDs for new/reordered rows
              getPopulateFSNotes(activeCat);
            } else {
              setFsNotesResponseData((prev) =>
                (prev || []).map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map((sg) => {
                      if (sg._id !== tableId) return sg;
                      return {
                        ...sg,
                        table: updatedRows,
                      };
                    }),
                  };
                })
              );
            }
          } else {
            swal("Error", response?.data?.error || "Unable to update the data", "error");
          }
        })
        .catch((error) => {
          swal("Error", error?.response?.data?.error || "Unable to save the data", "error");
        });
    } else {
      if (activeCat === "socie") {
        const normalizeParticular = (value) => String(value ?? "").trim();
        const previousRowsById = new Map(
          (rows || []).map((row) => [String(row?._id ?? ""), row])
        );
        const normalizeCellValue = (value) => {
          if (value === null || value === undefined) return String(value);
          if (typeof value === "number") return `number:${value}`;
          if (typeof value === "string") {
            const trimmed = value.trim();
            const numericValue = trimmed
              .replace(/,/g, "")
              .replace(/^\((.*)\)$/, "-$1");
            if (trimmed !== "" && Number.isFinite(Number(numericValue))) {
              return `number:${Number(numericValue)}`;
            }
            return `string:${trimmed}`;
          }
          return JSON.stringify(value);
        };
        let oldName = "";
        let newName = "";
        const renamedRow = (updatedRows || []).find((row) => {
          const prev = previousRowsById.get(String(row?._id ?? ""));
          if (
            prev &&
            normalizeParticular(prev.particular) !== normalizeParticular(row.particular)
          ) {
            oldName = normalizeParticular(prev.particular);
            newName = normalizeParticular(row.particular);
            return true;
          }
          return false;
        });

        if (renamedRow) {

          updatePopulateFSApiHandler(
            {
              category: "socie",
              projectID: project_id,
              groupID: renamedRow._id,
            },
            { particular: renamedRow.particular ?? "" }
          )
            .then(async (response) => {
              if (response?.data?.success === true) {
                const allFormulas = getAllCellFormulas(loadData);
                const cleanKey = (v) => String(v || "").toLowerCase().replace(/[^a-z0-9]/g, "");
                const cleanOld = cleanKey(oldName);
                const matchingFormulas = allFormulas.filter((f) => {
                  const fRow = String(f?.row || "").trim().toLowerCase();
                  return fRow === oldName.toLowerCase() || (cleanOld && cleanKey(fRow) === cleanOld);
                });

                if (matchingFormulas.length > 0) {
                  try {
                    await Promise.all(
                      matchingFormulas.map((f) =>
                        setStandaloneSocieCellFormula(
                          { projectID: project_id },
                          {
                            row: newName,
                            col: f.col || f.column || f.columnName,
                            type: f.type || "formula",
                            terms: f.terms,
                            link: f.link,
                            isBold: f.isBold,
                            formulaType: f.formulaType,
                          }
                        )
                      )
                    );
                  } catch (formulaErr) {
                    console.error("Failed to update SOCIE formula row references:", formulaErr);
                  }
                }

                await getPopulateFS("socie");
              } else {
                swal("Error", response?.data?.error || "Unable to rename the SOCIE row", "error");
              }
            })
            .catch((err) => {
              swal("Error", err?.response?.data?.error || "Unable to rename the SOCIE row", "error");
            });
          return;
        }

        // Patch a single edited cell so replacing the SOCIE collection does
        // not recreate rows and discard their existing link/formula metadata.
        const changedCells = [];
        (updatedRows || []).forEach((row) => {
          const previousRow = previousRowsById.get(String(row?._id ?? ""));
          if (!previousRow) return;
          Object.keys(row || {}).forEach((key) => {
            if (["_id", "isNewRow"].includes(key)) return;
            if (normalizeCellValue(previousRow[key]) !== normalizeCellValue(row[key])) {
              changedCells.push({ row, key, value: row[key] });
            }
          });
        });

        if (changedCells.length === 1) {
          const { row, key, value } = changedCells[0];
          updatePopulateFSApiHandler(
            {
              category: "socie",
              projectID: project_id,
              groupID: row._id,
            },
            { [key]: value }
          )
            .then((response) => {
              if (response?.data?.success === true) {
                getPopulateFS("socie");
              } else {
                swal("Error", response?.data?.error || "Unable to update the SOCIE cell", "error");
              }
            })
            .catch((err) => {
              swal("Error", err?.response?.data?.error || "Unable to update the SOCIE cell", "error");
            });
          return;
        }

        // Structural edits (add/delete/reorder) still replace the row collection.
        const cleanRows = (updatedRows || []).map(({ isNewRow, _id, cellFormulas, ...rest }) => rest);
        const existingFormulas = getAllCellFormulas(loadData);
        replaceSocieApiHandler(project_id, cleanRows)
          .then(async () => {
            if (existingFormulas?.length > 0) {
              await Promise.all(
                existingFormulas.map((f) =>
                  setStandaloneSocieCellFormula(
                    { projectID: project_id },
                    {
                      row: f.row,
                      col: f.col || f.column || f.columnName,
                      type: f.type || (f.link ? "link" : "formula"),
                      ...(f.terms ? { terms: f.terms } : {}),
                      ...(f.link ? { link: f.link } : {}),
                      ...(typeof f.isBold === "boolean" ? { isBold: f.isBold } : {}),
                      ...(f.formulaType ? { formulaType: f.formulaType } : {}),
                    }
                  )
                )
              );
            }
            await getPopulateFS("socie");
          })
          .catch((err) => console.error("replaceSocie error", err));
      } else if (activeCat === "cashflow") {
        const normalizeParticular = (value) => String(value ?? "").trim();
        const previousRowsById = new Map(
          (rows || []).map((row) => [String(row?._id ?? ""), row])
        );
        const renamedRow = (updatedRows || []).find((row) => {
          const previousRow = previousRowsById.get(String(row?._id ?? ""));
          return (
            previousRow &&
            normalizeParticular(previousRow.particular) !==
              normalizeParticular(row.particular)
          );
        });

        if (renamedRow) {
          setLoadingCount((prev) => prev + 1);
          updatePopulateFSApiHandler(
            {
              category: "cashflow",
              projectID: project_id,
              groupID: renamedRow._id,
            },
            { particular: renamedRow.particular ?? "" }
          )
            .then(async (response) => {
              if (response?.data?.success === true) {
                await getPopulateFS("cashflow");
                setSuccessMessage("Row renamed successfully");
                setShowSuccessPopup(true);
              } else {
                swal(
                  "Error",
                  response?.data?.error || "Unable to rename the Cashflow row",
                  "error"
                );
              }
            })
            .catch((err) => {
              swal(
                "Error",
                err?.response?.data?.error || "Unable to rename the Cashflow row",
                "error"
              );
            })
            .finally(() => {
              setLoadingCount((prev) => Math.max(0, prev - 1));
            });
          return;
        }

        // Cashflow: plain cell edits only (not add/delete/reorder handled separately)
        setLoadData(updatedRows);
      }
    }
  };

  // ── SOCIE helpers ─────────────────────────────────────────────────────
  const handleSocieRowAdd = (rowIdx, row) => {
    // FSTable triggers onRowAdd with the newly sealed row. 
    // The parent's `rows` state does not contain this row yet, so we must insert it.
    const newRows = [...(rows || [])];
    newRows.splice(rowIdx, 0, row);
    
    const cleanRows = newRows.map(({ isNewRow, _id, cellFormulas, ...rest }) => rest);
    const existingFormulas = getAllCellFormulas(loadData);
    replaceSocieApiHandler(project_id, cleanRows)
      .then(async () => {
        if (existingFormulas?.length > 0) {
          await Promise.all(
            existingFormulas.map((f) =>
              setStandaloneSocieCellFormula(
                { projectID: project_id },
                {
                  row: f.row,
                  col: f.col || f.column || f.columnName,
                  type: f.type || (f.link ? "link" : "formula"),
                  ...(f.terms ? { terms: f.terms } : {}),
                  ...(f.link ? { link: f.link } : {}),
                  ...(typeof f.isBold === "boolean" ? { isBold: f.isBold } : {}),
                  ...(f.formulaType ? { formulaType: f.formulaType } : {}),
                }
              )
            )
          );
        }
        await getPopulateFS("socie");
      })
      .catch((err) => console.error("replaceSocie add error", err));
  };

  const handleSocieRowDelete = (rowIdx, updatedRows) => {
    const deletedRow = rows?.[rowIdx];
    const deletedRowName = String(deletedRow?.particular || "").trim().toLowerCase();
    const existingFormulas = getAllCellFormulas(loadData).filter(
      (f) => String(f?.row || "").trim().toLowerCase() !== deletedRowName
    );
    const cleanRows = (updatedRows || []).map(({ isNewRow, _id, cellFormulas, ...rest }) => rest);
    replaceSocieApiHandler(project_id, cleanRows)
      .then(async () => {
        if (existingFormulas?.length > 0) {
          await Promise.all(
            existingFormulas.map((f) =>
              setStandaloneSocieCellFormula(
                { projectID: project_id },
                {
                  row: f.row,
                  col: f.col || f.column || f.columnName,
                  type: f.type || (f.link ? "link" : "formula"),
                  ...(f.terms ? { terms: f.terms } : {}),
                  ...(f.link ? { link: f.link } : {}),
                  ...(typeof f.isBold === "boolean" ? { isBold: f.isBold } : {}),
                  ...(f.formulaType ? { formulaType: f.formulaType } : {}),
                }
              )
            )
          );
        }
        await getPopulateFS("socie");
      })
      .catch((err) => console.error("replaceSocie delete error", err));
  };

  const handleSocieRowReorder = (fromIndex, toIndex, updatedRows) => {
    const cleanRows = (updatedRows || []).map(({ isNewRow, _id, cellFormulas, ...rest }) => rest);
    const existingFormulas = getAllCellFormulas(loadData);
    replaceSocieApiHandler(project_id, cleanRows)
      .then(async () => {
        if (existingFormulas?.length > 0) {
          await Promise.all(
            existingFormulas.map((f) =>
              setStandaloneSocieCellFormula(
                { projectID: project_id },
                {
                  row: f.row,
                  col: f.col || f.column || f.columnName,
                  type: f.type || (f.link ? "link" : "formula"),
                  ...(f.terms ? { terms: f.terms } : {}),
                  ...(f.link ? { link: f.link } : {}),
                  ...(typeof f.isBold === "boolean" ? { isBold: f.isBold } : {}),
                  ...(f.formulaType ? { formulaType: f.formulaType } : {}),
                }
              )
            )
          );
        }
        await getPopulateFS("socie");
      })
      .catch((err) => console.error("replaceSocie reorder error", err));
  };

  const handleSocieRowBold = (rIdx, row) => {
    updatePopulateFSApiHandler(
      {
        category: "socie",
        projectID: project_id,
        groupID: row._id,
      },
      { isBold: !!row.isBold }
    )
      .then((res) => {
        if (res?.data?.success) {
          getPopulateFS("socie");
        }
      })
      .catch((err) => console.error("Error updating SOCIE bold:", err));
  };

  // ── Cashflow helpers ─────────────────────────────────────────────────
  const handleCashflowRowAdd = (position, row) => {
    const payload = {
      particular: row.particular || "",
      lineType: row.lineType || "line item",
      position,
    };
    addCashflowRowApiHandler(project_id, payload)
      .then(() => getPopulateFS("cashflow"))
      .catch((err) => console.error("addCashflowRow error", err));
  };

  const handleCashflowRowBold = (rIdx, row) => {
    handleTableEdit({ _id: row._id, key: "isBold", value: row.isBold });
  };

  const handleCashflowRowDelete = (rowIdx) => {
    const deletedRow = rows?.[rowIdx];
    if (!deletedRow?._id) {
      swal("Error", "Unable to delete this Cashflow row: row ID is missing", "error");
      getPopulateFS("cashflow");
      return;
    }

    updatePopulateFSApiHandler(
      {
        category: "cashflow",
        projectID: project_id,
        groupID: deletedRow._id,
      },
      { deletedItemID: [deletedRow._id] }
    )
      .then((response) => {
        if (response?.data?.success === true) {
          getPopulateFS("cashflow");
        } else {
          swal("Error", response?.data?.error || "Unable to delete the Cashflow row", "error");
          getPopulateFS("cashflow");
        }
      })
      .catch((err) => {
        swal("Error", err?.response?.data?.error || "Unable to delete the Cashflow row", "error");
        getPopulateFS("cashflow");
      });
  };

  const handleCashflowRowReorder = (fromIndex, toIndex) => {
    rearrangeCashflowRowApiHandler(project_id, fromIndex, toIndex)
      .then(() => getPopulateFS("cashflow"))
      .catch((err) => console.error("rearrangeCashflowRow error", err));
  };

  const menuItems = [
    { label: "Balance Sheet", value: "BS" },
    { label: "P&L Statement", value: "PL" },
    { label: "Cashflow", value: "cashflow" },
    { label: "SOCIE", value: "socie" },
    { label: "General Notes", value: "general notes" },
    { label: "Balance Sheet Notes", value: "BS notes" },
    { label: "P&L Statement Notes", value: "PL notes" },
    { label: "Disclosures", value: "disclosure" },
    //{ label: "Disclosures Checklist", value: "checklist" },
  ];

  const getPopulateFS = (cat) => {
    const getParams = {
      category: cat,
      projectID: project_id,
    };
    setLoadingCount(prev => prev + 1);
    return getPopulateFSDetailsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const catData = response?.data?.data;
          setLoadData(catData);
          if (response.data.currentYear) setCurrentYearLabel(response.data.currentYear);
          if (response.data.previousYear) setPreviousYearLabel(response.data.previousYear);
        }
      })
      .catch((error) => {
        setLoadData([]);
      })
      .finally(() => {
        setLoadingCount(prev => Math.max(0, prev - 1));
      });
  };

  const refreshStandaloneCategoryData = async (category = activeCat) => {
    await getPopulateFS(category);
    if (["BS notes", "PL notes", "general notes", "disclosure"].includes(category)) {
      await getPopulateFSNotes(category);
    }
  };

  // ── Fetch data whenever activeCat changes ─────────────────────────────────
  useEffect(() => {
    setLoadingCount(prev => prev + 1); // Set loading immediately
    setColumns([]);
    setSubMenu(null);
    setIsNotes(false);
    setNotesData(null);
    setSubGroupId(null);
    setSubMenuId(null);
    setLoadData([]);
    setFsNotesResponseData(null);
    setRows([]);
    
    const fetchData = async () => {
      try {
        const catToUse = (activeCat === "cashflow" && showCashflowWorkings) ? "cashflowWorkings" : activeCat;
        await getPopulateFS(catToUse);
        if ([
          "BS notes",
          "PL notes",
          "general notes",
          "disclosure",
          "cashflowWorkings",
        ].includes(catToUse)) {
          await getPopulateFSNotes(catToUse);
        }
      } finally {
        setLoadingCount(prev => Math.max(0, prev - 1));
      }
    };

    fetchData();
  }, [activeCat, showCashflowWorkings]);

  const debounceTimer = useRef(null);

  const handleTableEdit = ({ _id, key, value, type = "table", tableId }) => {
    // SOCIE edits are handled in handleRowsChange (renames use the row update
    // endpoint; other edits replace the collection), avoiding duplicate calls.
    if (activeCat === "socie") return;
    if (activeCat === "cashflow" && key === "particular") return;

    const params = {
      category: activeCat,
      projectID: project_id,
    };

    if (isNotes && type !== "text") {
      params["groupID"] = subMenuId;
      if (activeCat === "checklist") {
        params["subgroupID"] = _id;
      } else {
        params["subgroupID"] = tableId;
        params["rowID"] = _id;
      }
    } else {
      if (
        activeCat === "BS" ||
        activeCat === "PL" ||
        activeCat === "socie" ||
        activeCat === "cashflow"
      ) {
        params["groupID"] = _id;
      }
    }

    const payload = {};

    if (isNotes && type === "text") {
      params["groupID"] = subMenuId;
      params["subgroupID"] = _id;
      payload["textRaw"] = key;
      payload["textPlain"] = value;
    } else {
      payload[key] = value;
    }

    let oldParticular = "";
    if (activeCat === "disclosure" && key === "particular") {
      const currentGroup = (fsNotesResponseData || []).find((g) => g._id === subMenuId);
      const currentSubgroup = (currentGroup?.subgroup || currentGroup?.subGroup || []).find((sg) => (sg._id || sg.id) === (tableId || subgroupId));
      const prevRow = (currentSubgroup?.table || []).find((r) => r._id === _id);
      oldParticular = String(prevRow?.particular || "").trim();
      const newParticular = String(value || "").trim();
      const cellFormulas = currentSubgroup?.cellFormulas || [];

      if (oldParticular && newParticular && oldParticular !== newParticular && cellFormulas.length > 0) {
        const cleanKey = (v) => String(v || "").toLowerCase().replace(/[^a-z0-9]/g, "");
        const cleanOld = cleanKey(oldParticular);
        const matchingFormulas = cellFormulas.filter((f) => {
          const fRow = String(f?.row || "").trim().toLowerCase();
          return fRow === oldParticular.toLowerCase() || (cleanOld && cleanKey(fRow) === cleanOld);
        });

        matchingFormulas.forEach(async (f) => {
          try {
            await setStandaloneDisclosureCellFormula(
              { projectID: project_id, disclosureID: subMenuId, subgroupID: tableId || subgroupId },
              {
                row: newParticular,
                col: f.col,
                type: f.type || "formula",
                terms: f.terms,
                link: f.link,
                isBold: f.isBold,
                formulaType: f.formulaType,
              }
            );
            if (cleanKey(f.row) !== cleanKey(newParticular) || f.row !== newParticular) {
              await deleteStandaloneDisclosureCellFormula({
                projectID: project_id,
                disclosureID: subMenuId,
                subgroupID: tableId || subgroupId,
                row: f.row,
                col: f.col,
              });
            }
          } catch (e) {
            console.warn("Failed to migrate disclosure formula on cell edit", e);
          }
        });
      }
    }

    const showCashflowSaveLoader = activeCat === "cashflow";
    if (showCashflowSaveLoader) {
      setLoadingCount((prev) => prev + 1);
    }

    updatePopulateFSApiHandler(params, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          if (isNotes) {
            if (type === "text") {
              // ── Update fsNotesResponseData (source of truth for notes) ────
              setFsNotesResponseData((prev) =>
                (prev || []).map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== _id) return sg;
                        return {
                          ...sg,
                          textRaw: payload.textRaw,
                          textPlain: payload.textPlain,
                        };
                      }
                    ),
                  };
                })
              );
            } else {
              // ── Update fsNotesResponseData (source of truth for notes) ────
              setFsNotesResponseData((prev) =>
                (prev || []).map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        const targetId = tableId || subgroupId;
                        if (sg._id !== targetId && sg._id !== subgroupId && sg._id !== tableId) return sg;
                        const isParticularEdit = key === "particular" && oldParticular;
                        return {
                          ...sg,
                          table: (sg.table || []).map((row) =>
                            row._id === _id ? { ...row, [key]: value } : row
                          ),
                          cellFormulas: isParticularEdit
                            ? (sg.cellFormulas || []).map((f) => {
                                const cleanKey = (v) => String(v || "").toLowerCase().replace(/[^a-z0-9]/g, "");
                                const cleanOld = cleanKey(oldParticular);
                                const fRow = String(f?.row || "").trim().toLowerCase();
                                if (fRow === oldParticular.toLowerCase() || (cleanOld && cleanKey(fRow) === cleanOld)) {
                                  return { ...f, row: value };
                                }
                                return f;
                              })
                            : sg.cellFormulas,
                        };
                      }
                    ),
                  };
                })
              );
            }
          } else {
            // Non-notes tables (BS, PL, socie, cashflow)
            setRows((prev) =>
              prev.map((row) =>
                row._id === _id ? { ...row, [key]: value } : row
              )
            );
          }
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update the data",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to save the data",
          "error"
        );
      })
      .finally(() => {
        if (showCashflowSaveLoader) {
          setLoadingCount((prev) => Math.max(0, prev - 1));
        }
      });
  };

  const handleTableEditDebounced = (args) => {
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      handleTableEdit(args);
    }, 2000);
  };

  useEffect(() => {
    return () => clearTimeout(debounceTimer.current);
  }, []);

 const ShowDetails = () => {

  const formatIndianNumber = (val) => {
    if (val == null) return "";
    const num = Number(val);
    if (isNaN(num)) return val;

    if (num < 0) {
      return "(" + Math.abs(num).toLocaleString("en-IN") + ")";
    }
    return num.toLocaleString("en-IN");
  };

  const formattedRows =
    activeCat === "socie" || activeCat === "cashflow"
      ? rows.map((row) => {
          const newRow = { ...row };

          Object.keys(newRow).forEach((key) => {
            const lower = key.toLowerCase();
            if (
              key !== "_id" &&
              key !== "lineType" &&
              key !== "references" &&
              key !== "particular" &&
              key !== "cellFormulas" &&
              key !== "originalLineType" &&
              key !== "formulaType" &&
              key !== "rowId" &&
              lower !== "isbold" &&
              lower !== "derivedfromworkings" &&
              lower !== "groupingid" &&
              lower !== "grouping id" &&
              newRow[key] !== null &&
              newRow[key] !== undefined &&
              typeof newRow[key] !== "boolean" &&
              !Array.isArray(newRow[key]) &&
              !isNaN(Number(newRow[key]))   
            ) {
              newRow[key] = formatIndianNumber(newRow[key]);
            }
          });

          return newRow;
        })
      : rows;

  return (
    <FSTable
      columns={filteredColumns}
      rows={formattedRows}
      onRowsChange={handleRowsChange}
      onCellChangeImmediate={handleTableEditDebounced}
      redirectTo={redirectTo}
      enableHoverLink={activeCat === "socie" || activeCat === "cashflow"}
      hoverLinkColumns={activeCat === "cashflow" ? ['currentYear', 'previousYear'] : true}
      cellFormulas={getAllCellFormulas(loadData)}
      onCellLinkClick={handleCellLinkClick}
      selectedCell={selectedCell}
      showLinkPanel={showLinkPanel}
      tableDataID={loadData?.[0]?._id}
      activeCat={activeCat}
      allowDragAndAdd={
        !["BS", "PL", "BS notes", "PL notes", "checklist"].includes(activeCat)
      }
      onRowAdd={
        activeCat === "socie"
          ? handleSocieRowAdd
          : activeCat === "cashflow"
          ? handleCashflowRowAdd
          : null
      }
      onRowDelete={
        activeCat === "socie"
          ? handleSocieRowDelete
          : activeCat === "cashflow"
          ? handleCashflowRowDelete
          : (activeCat === "BS" || activeCat === "PL")
          ? handleBSPLRowDelete
          : null
      }
      onRowReorder={
        activeCat === "cashflow"
          ? handleCashflowRowReorder
          : activeCat === "socie"
          ? handleSocieRowReorder
          : null
      }
      onRowBoldToggle={
        activeCat === "cashflow"
          ? handleCashflowRowBold
          : activeCat === "socie"
          ? handleSocieRowBold
          : null
      }
    />
  );
};

  const ShowChecklist = ({ subMenuId }) => {
    if (!subMenu) return null;

    const selNote = subMenu.submenu.find((item) => item.value === subMenuId);
    const rows = selNote?.subGroup || [];

    const checklistColumns = [
      {
        label: "Paragraph reference",
        field: "reference",
        align: "left",
        editable: false,
        type: "popup",
      },
      {
        label: "Disclosure",
        field: "notes",
        align: "left",
        maxWidth: 200,
        editable: false,
        type: "text",
      },
      {
        label: "Yes",
        field: "value",
        optionValue: "Y",
        align: "center",
        editable: true,
        type: "checkbox",
      },
      {
        label: "No",
        field: "value",
        optionValue: "N",
        align: "center",
        editable: true,
        type: "checkbox",
      },
      {
        label: "NA",
        field: "value",
        optionValue: "NA",
        align: "center",
        editable: true,
        type: "checkbox",
      },
      {
        label: "Remarks",
        field: "remark",
        align: "left",
        editable: true,
        type: "text",
        placeholder: "Enter remarks here...",
      },
    ];

    return (
      <>
        <FSTable
          columns={checklistColumns}
          rows={rows}
          onRowsChange={handleRowsChange}
          onCellChangeImmediate={handleTableEditDebounced}
          redirectTo={redirectTo}
        />
      </>
    );
  };

  const getPopulateFSNotes = async (cat) => {
    try {
      setLoadingCount(prev => prev + 1);
      const getParams = {
        category: cat,
        projectID: project_id,
      };

      const response = await getPopulateFSDetailsApiHandler(getParams);

      if (response?.data?.success === true) {
        setFsNotesResponseData(response.data.data);
        if (response.data.currentYear) setCurrentYearLabel(response.data.currentYear);
        if (response.data.previousYear) setPreviousYearLabel(response.data.previousYear);
        return response.data.data;
      }

      return [];
    } catch (error) {
      console.error(error);
      return [];
    } finally {
      setLoadingCount(prev => Math.max(0, prev - 1));
    }
  };

  const triggerRedirectSearch = (searchPayload, sourceRows) => {
    const searchArg = String(searchPayload.arg || "").trim().toLowerCase();
    const searchPart = String(searchPayload.particular || "").trim().toLowerCase();

    const normalize = (str) => String(str || "").replace(/[^a-z0-9]/gi, "").toLowerCase();
    const normPart = normalize(searchPart);

    let foundNoteId = null;
    let foundSubGroupId = null;

    // 1. Try to find the Note Header - Exact match first
    let directMatch = null;
    
    // Pass 1: Prioritize exact ID match if we have a groupingID
    if (searchPayload.groupingID) {
      directMatch = sourceRows.find(item => 
        item.groupingID === searchPayload.groupingID || item._id === searchPayload.groupingID
      );
    }

    // Pass 2: Fallback to note number match
    if (!directMatch && searchArg) {
      directMatch = sourceRows.find(item => {
        const itemNote = String(item.notes || "").trim().toLowerCase();
        return itemNote === searchArg;
      });
    }

    // Pass 3: Fallback to name match ONLY if no ID and no note number match was found
    if (!directMatch) {
      directMatch = sourceRows.find(item => {
        const itemName = String(item.particular || "").trim().toLowerCase();
        const normItemName = normalize(itemName);

        return (
          (normPart && normItemName === normPart) ||
          (searchPart && itemName === searchPart)
        );
      });
    }

    // Fallback to partial match if no exact match
    if (!directMatch) {
      directMatch = sourceRows.find(item => {
        const itemName = String(item.particular || "").trim().toLowerCase();
        const itemNote = String(item.notes || "").trim().toLowerCase();
        const normItemName = normalize(itemName);

        return (
          (normPart && (normItemName.includes(normPart) || normPart.includes(normItemName))) ||
          (searchArg && (itemNote.includes(searchArg) || searchArg.includes(itemNote))) ||
          (searchPart && (itemName.includes(searchPart) || searchPart.includes(itemName)))
        );
      });
    }

    if (directMatch) {
      foundNoteId = directMatch._id;
      
      // 2. Try to find the specific subgroup/table inside that note
      const sgs = directMatch.subgroup || directMatch.subGroup || [];
      
      // Exact match for subgroup
      let matchingSg = sgs.find(sg => {
        const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
        const normTitle = normalize(title);
        return normPart && normTitle === normPart;
      });

      // Partial match for subgroup
      if (!matchingSg) {
        matchingSg = sgs.find(sg => {
          const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
          return title.includes(searchPart) || searchPart.includes(title);
        });
      }
      
      if (matchingSg) foundSubGroupId = matchingSg._id;
    } else {
      // 3. Fallback: Search across all subgroups if Note Header didn't match
      for (const item of sourceRows) {
        const sgs = item.subgroup || item.subGroup || [];
        
        let foundSg = sgs.find(sg => {
          const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
          const normTitle = normalize(title);
          return normPart && normTitle === normPart;
        });

        if (!foundSg) {
          foundSg = sgs.find(sg => {
            const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
            return title.includes(searchPart) || searchPart.includes(title);
          });
        }

        if (foundSg) {
          foundNoteId = item._id;
          foundSubGroupId = foundSg._id;
          break;
        }
      }
    }

    if (foundNoteId) {
      setSubMenuId(foundNoteId);
      setRedirectNote(foundNoteId);
      if (foundSubGroupId) {
        setTargetSubGroupId(foundSubGroupId);
        setSubGroupId(foundSubGroupId);
      }
      setRedirectSearch(null);
    } else if (activeCat === searchPayload.targetCat && sourceRows.length > 0) {
      setRedirectSearch(null);
    }
  };

  const redirectTo = (arg, row) => {
    let targetCat = null;

    if (activeCat === "BS") {
      targetCat = "BS notes";
    } else if (activeCat === "PL") {
      targetCat = "PL notes";
    } else {
      targetCat = activeCat;
    }

    if (targetCat) {
      const searchPayload = {
        arg: arg,
        particular: row?.particular,
        groupingID: row?._id || row?.groupingID || row?.groupingid,
        targetCat: targetCat
      };
      console.log("Redirect search payload:", searchPayload, "from row:", row);
      setRedirectSearch(searchPayload);
      
      if (targetCat === activeCat) {
        triggerRedirectSearch(searchPayload, fsNotesResponseData || []);
      } else {
        setActiveCat(targetCat);
      }
    }
  };

  useEffect(() => {
    if (!redirectSearch || activeCat !== redirectSearch.targetCat || !isNotes || !fsNotesResponseData) return;
    triggerRedirectSearch(redirectSearch, fsNotesResponseData);
  }, [redirectSearch, isNotes, fsNotesResponseData, activeCat]);

  useEffect(() => {
    if (targetSubGroupId && isNotes) {
      const timer = setTimeout(() => {
        // Try to scroll to specific row first
        const normalize = (str) => String(str || "").replace(/[^a-z0-9]/gi, "").toLowerCase();
        const rowId = redirectSearch?.particular ? normalize(redirectSearch.particular) : null;
        
        const rowElement = rowId ? document.getElementById(rowId) : null;
        const tableElement = document.getElementById(targetSubGroupId);
        
        const element = rowElement || tableElement;

        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.classList.add(commoncss.noteSectionHighlight);
          setTimeout(() => element.classList.remove(commoncss.noteSectionHighlight), 2000);
          setTargetSubGroupId(null);
        }
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [targetSubGroupId, isNotes, subMenuId]);

  // ── FIX: depend on fsNotesResponseData + subMenuId, NOT on rows ───────────
  // Previously `rows` was in the dep array which caused this to re-run
  // whenever rows changed (often), and at that moment fsNotesResponseData
  // could still be null → selNote = undefined → notesData wiped incorrectly.
  useEffect(() => {
    console.log("=== subMenuId ===", subMenuId);
    console.log("=== fsNotesResponseData ===", fsNotesResponseData);
    console.log("=== isNotes ===", isNotes);
    console.log("=== activeCat ===", activeCat);

    if (!isNotes && !(activeCat === "cashflow" && showCashflowWorkings)) {
      setNotesData(null);
      return;
    }
    if (activeCat === "checklist") {
      setNotesData(null);
      return;
    }

    const source = fsNotesResponseData ?? [];
    if (activeCat === "cashflow" && showCashflowWorkings) {
      if (!subMenuId) {
        setNotesData(source[0] || null);
        return;
      }
    }

    if (!subMenuId) {
      setNotesData(null);
      return;
    }

    const selNote = source.find((item) => item._id === subMenuId) || null;
    
    console.log("=== selNote found ===", selNote);
    setNotesData(selNote);
  }, [isNotes, activeCat, showCashflowWorkings, subMenuId, fsNotesResponseData]);
  // ─────────────────────────────────────────────────────────────────────────

  // ── Auto-select first table subgroup within a note ────────────────────────
  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !notesData) return;

    const subGroups = notesData.subgroup || notesData.subGroup || [];
    const firstTableSg = subGroups.find(
      (sg) => (sg?.dataType ?? sg?.datatype) === "table"
    );

    setSubGroupId(firstTableSg?._id ?? null);
  }, [isNotes, activeCat, notesData]);

  const showNotesDetails = (noteId) => {
    if (checkUnsaved()) return;
    setSubMenuId(noteId);
  };

  const deletePopulateFS = async (subgroupID) => {
    try {
      if (["general notes", "disclosure"].includes(activeCat)) {
        setLoadingCount((prev) => prev + 1);
        const params = {
          category: activeCat,
          projectID: project_id,
          groupID: notesData?._id,
          subgroupID: subgroupID
        };
        const res = await deletePopulateFSApiHandler(params);
        if (res?.data?.success || res?.status === 200) {
           setSuccessMessage("Deleted successfully");
           setShowSuccessPopup(true);
           await refreshStandaloneCategoryData();
           setUpdateTrigger(prev => prev + 1);
        } else {
           swal("Error", res?.data?.message || "Failed to delete", "error");
        }
        setLoadingCount((prev) => prev - 1);
        return [];
      } else {
        let deletedItem = null;
        let noteName = notesData?.title || notesData?.name || "Untitled";

        if (notesData) {
          const subGroups = notesData.subgroup || notesData.subGroup || [];
          const sg = subGroups.find(s => s._id === subgroupID);
          if (sg) {
            deletedItem = {
              id: subgroupID,
              section: activeCat,
              tab: noteName,
              data: sg,
              noteData: notesData
            };
            setDeletedItems(prev => [...prev, deletedItem]);
          }
        }
        return [];
      }
    } catch (error) {
      console.error(error);
      if (["general notes", "disclosure"].includes(activeCat)) {
        setLoadingCount((prev) => Math.max(prev - 1, 0));
        swal("Error", error?.response?.data?.message || "Failed to delete", "error");
      }
      return [];
    }
  };

  // ── Re-sync notesData after a delete (updateTrigger bump) ─────────────────
  // Also reads from fsNotesResponseData, not rows
  useEffect(() => {
    if (!isNotes && !(activeCat === "cashflow" && showCashflowWorkings)) {
      setNotesData(null);
      return;
    }
    if (activeCat === "checklist") {
      setNotesData(null);
      return;
    }

    const source = fsNotesResponseData ?? [];
    if (activeCat === "cashflow" && showCashflowWorkings) {
      if (!subMenuId) {
        setNotesData(source[0] || null);
        return;
      }
    }

    if (!subMenuId) {
      setNotesData(null);
      return;
    }

    const selNote = source.find((item) => item._id === subMenuId) || null;
    setNotesData(selNote);
  }, [updateTrigger, isNotes, activeCat, showCashflowWorkings, subMenuId, fsNotesResponseData]);
  // ─────────────────────────────────────────────────────────────────────────

  const renderSubGroups = (notesData, overrideCategory = null) => {
    const currentCategory = overrideCategory || activeCat;
    
    const activeBottomBlockSubgroupIDs = bottomBlocks
      .map((b) => b.subgroupID)
      .filter(Boolean);

    const subGroups = (notesData?.subgroup || notesData?.subGroup || []).filter((sg) => {
      if (overrideCategory) return true;
      if (deletedItems.find((di) => di.id === sg._id)) return false;
      if (activeBottomBlockSubgroupIDs.includes(sg._id)) return false;
      return true;
    });

    const relatedTables = [];
    const normalTables = [];
    let relatedPartyTitle = "";

    subGroups.forEach((sg, idx) => {
      console.log("----- TABLE DEBUG -----");
      console.log("Category:", currentCategory);
      console.log("Data Type:", sg?.dataType ?? sg?.datatype ?? sg?.type);
      console.log("Table Type:", sg?.tableType);
      console.log("Table Rows:", sg?.table?.length);
      console.log("Is Related Party:", sg?.tableType === "related party");
      console.log("-----------------------");

      const type = sg?.dataType ?? sg?.datatype ?? sg?.type ?? "";

      const isCustom = sg?.isCustom === true || sg?.tableType === "default" || sg?.tableType === "content";
      if (currentCategory === "cashflow" && showCashflowWorkings && type === "table" && !isCustom) {
        return;
      }

      if (type === "table") {
        const formatIndianNumber = (val) => {
        if (val == null) return "";
        const num = Number(val);
        if (isNaN(num)) return val;

        if (num < 0) {
          return "(" + Math.abs(num).toLocaleString("en-IN") + ")";
        }
        return num.toLocaleString("en-IN");
      };

      const isNotesTable =
        currentCategory === "BS notes" || currentCategory === "PL notes";

      const tableItems = (Array.isArray(sg.table) ? sg.table : []).map((row) => {
        if (!isNotesTable) return row;

        const newRow = { ...row };

        Object.keys(newRow).forEach((key) => {
          if (
            key !== "_id" &&
            key !== "references" &&
            key !== "particular" &&
            key !== "lineType" &&
            newRow[key] !== null &&
            newRow[key] !== undefined &&
            !isNaN(Number(newRow[key]))
          ) {
            newRow[key] = formatIndianNumber(newRow[key]);
          }
        });

        return newRow;
      });

      const itemsToRender = tableItems.length > 0 
        ? tableItems 
        : [ (sg.tableColumn || []).reduce((acc, col) => ({ ...acc, [col.name]: "" }), {}) ];

      const catRows = Object.keys(itemsToRender[0] || {});
      const filteredCols = catRows.filter((col) => col !== "_id");

      const orderedCols = isNotesTable
        ? [
            ...filteredCols.filter((col) => {
              const lower = col.toLowerCase().trim();
              return ![
                "references",
                "linetype",
                "line type",
                "line-type",
                "isbold",
                "formulatype",
                "currentyear",
                "previousyear",
                "derivedfromworkings",
                "isnewrow",
                "issubrow",
                "is sub row",
                "is_sub_row",
                "is-sub-row",
                "subrow",
                "isnew"
              ].includes(lower);
            }),
              ...filteredCols
                .filter((col) => {
                  const lower = col.toLowerCase().trim();
                  return lower === "currentyear" || lower === "previousyear";
                })
                .sort((a, b) => {
                  if (a.toLowerCase() === "currentyear") return -1;
                  return 1;
                }),
            ]
          : [
              ...filteredCols.filter((col) => {
                const lower = String(col).toLowerCase().trim();
                const isLineType = lower === "linetype" || lower === "line type" || lower === "line-type";
                const isBold = lower === "isbold";
                const isFormulaType = lower === "formulatype";
                const isSubRow =
                  lower === "issubrow" ||
                  lower === "is sub row" ||
                  lower === "is_sub_row" ||
                  lower === "is-sub-row" ||
                  lower === "subrow";
                const isNewRow = lower === "isnewrow" || lower === "isnew";
                return (
                  col !== "references" &&
                  !isLineType &&
                  !isBold &&
                  !isFormulaType &&
                  !isSubRow &&
                  !isNewRow &&
                  lower !== "derivedfromworkings" &&
                  lower !== "groupingid" &&
                  lower !== "grouping id"
                );
              }),
            ];

    const tableCols = orderedCols.map((col) => {
  if (col === "references") {
    return {
      label: col,
      field: col,
      align: "left",
      editable: false,
      type: "checklistref",
    };
  }

  const isNotesTable =
    currentCategory === "BS notes" || currentCategory === "PL notes";

  const lowerCol = col.toLowerCase();

  // ✅ Identify columns
  const isParticular = lowerCol === "particular";
  const isLineType =
    lowerCol === "linetype" || lowerCol === "line type";
if (isNotesTable) {
  let labelVal = col;
  if (lowerCol === "currentyear") labelVal = currentYearLabel || "Current Year";
  else if (lowerCol === "previousyear") labelVal = previousYearLabel || "Previous Year";

  return {
    label: labelVal,
    field: col,

    align: isParticular || isLineType ? "left" : "right",

    editable: isCustom || sg?.tableType === "default" || sg?.tableType === "content",
    type: "text",


    width: isParticular
      ? "85%"
      : isLineType
      ? 200
      : 80,

    minWidth: isParticular
      ? 600
      : isLineType
      ? 200
      : 80,

    maxWidth: isParticular
      ? "85%"
      : isLineType
      ? 200
      : 80,

   
    headerStyle: {
      width: isParticular
        ? "85%"
        : isLineType
        ? 200
        : 80,
      minWidth: isParticular
        ? 600
        : isLineType
        ? 200
        : 80,
      maxWidth: isParticular
        ? "85%"
        : isLineType
        ? 200
        : 80,
      textAlign: isParticular || isLineType ? "left" : "right",
    },
  };
}
 
 
  const isPercentage =
    lowerCol.includes("percentage") || lowerCol.includes("%");

  const nonValRows = tableItems.filter((row) => {
    const v = row[col];
    return v !== null && v !== undefined && String(v).trim() !== "";
  });

  const isPurelyNumeric =
    nonValRows.length > 0 &&
    nonValRows.every((row) => {
      const v = row[col];
      const str = String(v).trim().replace(/,/g, "").replace(/\(/g, "-").replace(/\)/g, "");
      return !isNaN(Number(str));
    });

  const isNumeratorDenominator = lowerCol.includes("numerator") || lowerCol.includes("denominator");
  const isReasonForVariance = lowerCol.includes("reasonforvariance") || lowerCol.includes("reason for variance");

  const isTextDefault =
    lowerCol.includes("particular") ||
    lowerCol.includes("name") ||
    isNumeratorDenominator ||
    isReasonForVariance ||
    (lowerCol.includes("relationship") && sg?.tableType === "related party") ||
    lowerCol.includes("description") ||
    (["disclosure", "general notes"].includes(currentCategory) &&
      sg?.tableType !== "related party" &&
      !isPurelyNumeric &&
      !lowerCol.includes("currentyear") &&
      !lowerCol.includes("previousyear"));

  const defaultAlign = (isTextDefault || isNumeratorDenominator || isReasonForVariance || !isPurelyNumeric) && !isPercentage ? "left" : "right";
  
  const isParticularCol = lowerCol.includes("particular");

  const isDateCol =
    lowerCol === "date" ||
    lowerCol.includes("dateofvaluation") ||
    lowerCol.includes("date of valuation") ||
    lowerCol.includes("valuationdate") ||
    lowerCol.includes("valuation date") ||
    lowerCol.includes("date");

  const isMonthCol = lowerCol.includes("month") || lowerCol.includes("months");

  let finalAlign = defaultAlign;
  if (isDateCol || isMonthCol) {
    finalAlign = "center";
  } else if (isReasonForVariance) {
    finalAlign = "right";
  }

  let labelVal = col;
  if (lowerCol === "currentyear") labelVal = currentYearLabel || "Current Year";
  else if (lowerCol === "previousyear") labelVal = previousYearLabel || "Previous Year";

  return {
    label: labelVal,
    field: col,
    align: finalAlign,
    editable: (currentCategory === "cashflow" && (lowerCol === "currentyear" || lowerCol === "previousyear")) ? false : true,
    type: isPercentage || defaultAlign === "right" ? "number" : "text",
    width: isParticularCol ? "40%" : isNumeratorDenominator ? 220 : (isDateCol ? 120 : "auto"),
    minWidth: isParticularCol ? 300 : isNumeratorDenominator ? 220 : (isDateCol ? 100 : (defaultAlign === "right" ? 120 : 150)),
    maxWidth: isParticularCol ? "60%" : (isDateCol ? 140 : undefined),
    headerWhiteSpace: isReasonForVariance ? "nowrap" : undefined,
  };
});
        const isHoverLinkEnabled = currentCategory === "disclosure";
        const disclosureHoverColumns = tableCols
          .filter((col) => {
            const lowerField = String(col.field || "").toLowerCase();
            return lowerField.includes("currentyear") || lowerField.includes("previousyear");
          })
          .map((col) => col.field);
        const tableComponent = (
          <FSTable
            key={sg._id}
            columns={tableCols}
            rows={tableItems}
            onRowsChange={(updated) => handleRowsChange(updated, sg._id)}
            onCellChangeImmediate={handleTableEditDebounced}
            redirectTo={redirectTo}
            tableTitle={sg?.tableTitle}
            tableId={sg?._id || sg?.id}
            tableType={sg?.tableType}
            deletePopulateFS={
              (["general notes", "disclosure"].includes(currentCategory) || (isCustom && ["BS notes", "PL notes"].includes(currentCategory))) 
                ? deletePopulateFS 
                : (["BS notes", "PL notes"].includes(currentCategory) ? null : undefined)
            }
            enableHoverLink={isHoverLinkEnabled}
            hoverLinkColumns={isHoverLinkEnabled ? disclosureHoverColumns : []}
            cellFormulas={sg.cellFormulas || []}
            onCellLinkClick={handleCellLinkClick}
            tableDataID={sg?._id || sg?.id}
            onRowDelete={isHoverLinkEnabled ? (rIdx, updated) => handleRowsChange(updated, sg?._id || sg?.id) : undefined}
            allowDragAndAdd={
              isCustom ? true : !["BS", "PL", "BS notes", "PL notes", "checklist"].includes(currentCategory)
            }
            selectedCell={selectedCell}
            showLinkPanel={showLinkPanel}
            activeCat={currentCategory}
            useRowActionMenu={
              sg?.tableType === "transactions" ||
              sg?.tableType === "outstanding balances" ||
              (typeof sg?.tableTitle === "string" && (
                sg.tableTitle.toLowerCase().includes("transaction") ||
                sg.tableTitle.toLowerCase().includes("outstanding balance")
              ))
            }
          />
        );

        if (sg?.tableType === "related party") {
          const relatedTableComponent = (
            <div 
              key={sg._id} 
              className={bookclosurecss.relatedTableWrapper}
              style={{ 
                borderRadius: currentCategory === "disclosure" ? "0px" : "10px",
                border: currentCategory === "disclosure" ? "none" : undefined
              }}
            >
              {currentCategory !== "disclosure" && (
                <div className={bookclosurecss.relatedTableTitle}>
                  {sg?.tableTitle || "Related party disclosures"}
                </div>
              )}
              <div
                className={bookclosurecss["relatedTable-content"]}
                style={{
                  borderRadius:
                    currentCategory === "disclosure" ? "0px 0px 12px 12px" : "12px",
                  padding: 0,
                  margin: 0
                }}
              >
                <FSTable
                  columns={tableCols}
                  rows={tableItems}
                  onRowsChange={(updated) => handleRowsChange(updated, sg?._id || sg?.id)}
                  onCellChangeImmediate={handleTableEditDebounced}
                  redirectTo={redirectTo}
                  tableTitle={currentCategory === "disclosure" ? null : sg?.tableTitle}
                  tableId={sg?._id || sg?.id}
                  tableType={sg?.tableType}
                  deletePopulateFS={["general notes", "disclosure"].includes(currentCategory) ? deletePopulateFS : (["BS notes", "PL notes"].includes(currentCategory) ? null : undefined)}
                  enableHoverLink={isHoverLinkEnabled}
                  hoverLinkColumns={isHoverLinkEnabled ? disclosureHoverColumns : []}
                  cellFormulas={sg.cellFormulas || []}
                  onCellLinkClick={handleCellLinkClick}
                  tableDataID={sg?._id || sg?.id}
                  allowDragAndAdd={
                    !["BS", "PL", "BS notes", "PL notes", "checklist"].includes(currentCategory)
                  }
                  onRowDelete={isHoverLinkEnabled ? (rIdx, updated) => handleRowsChange(updated, sg?._id || sg?.id) : undefined}
                  selectedCell={selectedCell}
                  showLinkPanel={showLinkPanel}
                  activeCat={currentCategory}
                />
              </div>
            </div>
          );
          relatedTables.push(relatedTableComponent);
        } else {
          normalTables.push(tableComponent);
        }
      }

      if (type === "text") {
        normalTables.push(
          <div key={sg._id} style={{ paddingTop: "20px"}}>
            <QuillReactEditor
              key={sg._id}   
              value={sg?.textRaw ?? sg?.text?.[0]?.content ?? sg?.components?.[0]?.text ?? ""}
              onChange={(content) => {
                handleTableEdit({
                  _id: sg?._id,
                  key: content.html,
                  value: content.text,
                  type: "text",
                });
              }}
              rightControl={
                ["general notes", "disclosure"].includes(currentCategory) ? (
                  <div
                    style={{ cursor: "pointer", marginLeft: "10px", display: "flex", alignItems: "center" }}
                    onClick={() => {
                      setDeleteConfirm({
                        title: "Are you sure?",
                        message: "You want to delete this text block?",
                        onConfirm: async () => {
                          setDeleteConfirm(null);
                          await deletePopulateFS(sg._id);
                        }
                      });
                    }}
                  >
                    <DelIcon style={{ width: 16, height: 16 }} />
                  </div>
                ) : null
              }
            />
          </div>
        );
      }
    });

    return (
      <>
        {relatedTables.length > 0 && (
          <ViewRPTTransactions
            apiResponseData={fsNotesResponseData}
            getPopulateFSNotes={getPopulateFSNotes}
            refreshCategoryData={refreshStandaloneCategoryData}
            currentCategory={currentCategory}
            notesData={notesData}
            tableTitle={relatedPartyTitle}
            isDisclosure={currentCategory === "disclosure"}
          >
            {relatedTables}
          </ViewRPTTransactions>
        )}
        {normalTables}
      </>
    );
  };

  const [showAdjustmentLog, setShowAdjustmentLog] = useState(false);

  const formatIndianNumber = (val) => {
  if (val == null) return "";
  const num = Number(val);
  if (isNaN(num)) return val;

  if (num < 0) {
    return "(" + Math.abs(num).toLocaleString("en-IN") + ")";
  }
  return num.toLocaleString("en-IN");
};

  const handleBSPLRowDelete = async (rIdx, updated) => {
    const row = rows[rIdx];
    if (!row) return;
    try {
      setLoadingCount(prev => prev + 1);
      const params = {
        projectID: project_id,
        level: row.level
      };
      if (row.levelOneID) params.levelOneID = row.levelOneID;
      if (row.levelTwoID) params.levelTwoID = row.levelTwoID;
      if (row.levelThreeID) params.levelThreeID = row.levelThreeID;

      const res = await deletePopulateFSGroupingItemApiHandler(params);
      if (res?.data?.success) {
        setSuccessMessage("Line item moved to bin successfully");
        setShowSuccessPopup(true);
        await refreshStandaloneCategoryData();
        setUpdateTrigger(prev => prev + 1);
      } else {
        swal("Error", res?.data?.message || "Failed to delete item", "error");
      }
    } catch (err) {
      console.error(err);
      swal("Error", err.response?.data?.message || "Failed to delete item", "error");
    } finally {
      setLoadingCount(prev => prev - 1);
    }
  };

  const transformData = (data) => {
    const output = [];

    const walk = (node, l1Id, l2Id) => {
      if (node.level === 3) return;
      const type = (node.level === 1 && (activeCat === "BS" || activeCat === "PL")) ? (node.lineType || "row") : (node.level === 1 ? "header" : "row");
      
      const levelOneID = node.level === 1 ? node._id : l1Id;
      const levelTwoID = node.level === 2 ? node._id : l2Id;
      const levelThreeID = node.level === 3 ? node._id : null;

      output.push({
        _id: node._id,
        lineType: type,
        originalLineType: node.lineType,
        level: node.level,
        levelOneID,
        levelTwoID,
        levelThreeID,
        particular: node.name,
        notes: node.notes ?? null,
        currentYear: node.currentYear ?? null,
        previousYear: node.previousYear ?? null,
        references: node.references ?? [],
        isBold: node.isBold !== undefined ? node.isBold : node.isbold,
      });

      if (node.subgroup && node.subgroup.length) {
        node.subgroup.forEach(sub => walk(sub, levelOneID, levelTwoID));
      }
    };

    data.forEach(n => walk(n, null, null));
    return output;
  };



  const handleRestoreSelected = async () => {
    setRestoreConfirm({
      title: "Restore Items",
      message: "Are you sure you want to restore these selected items?",
      onConfirm: async () => {
        setRestoreConfirm(null);
        if (["General Notes", "Disclosures", "Balance Sheet", "P&L Statement"].includes(activeBinSection)) {
          if (selectedBinItems.length > 0) {
            try {
              await restorePopulateFSDeletedItemsApiHandler({ projectID: project_id }, { deletedItemID: selectedBinItems });
              setUpdateTrigger(prev => prev + 1);
              setSuccessMessage("Items successfully restored!");
              setShowSuccessPopup(true);
            } catch (err) {
              console.error("Error bulk restoring", err);
            }
          }
        } else {
          setDeletedItems(prev => prev.filter(di => !selectedBinItems.includes(di.id)));
          setSuccessMessage("Items successfully restored!");
          setShowSuccessPopup(true);
        }
        setSelectedBinItems([]);
      }
    });
  };

  const handleDeletePermanently = async () => {
    setDeleteConfirm({
      title: "Delete Permanently",
      message: "Are you sure you want to permanently delete these items? This action cannot be undone.",
      onConfirm: async () => {
        setDeleteConfirm(null);
        if (["General Notes", "Disclosures", "Balance Sheet", "P&L Statement"].includes(activeBinSection)) {
          if (selectedBinItems.length > 0) {
            try {
              await permanentDeletePopulateFSItemsApiHandler({ projectID: project_id }, { deletedItemID: selectedBinItems });
              setUpdateTrigger(prev => prev + 1); // Refresh bin
              setSuccessMessage("Items permanently deleted!");
              setShowSuccessPopup(true);
            } catch (err) {
              console.error("Error bulk permanent deleting", err);
            }
          }
        } else {
          setDeletedItems(prev => prev.filter(di => !selectedBinItems.includes(di.id)));
          setSuccessMessage("Items permanently deleted!");
          setShowSuccessPopup(true);
        }
        setSelectedBinItems([]);
      }
    });
  };

  const handleDeleteSubGroup = async (category, groupID) => {
    try {
      await deletePopulateFSSectionApiHandler(
        { projectID: project_id, category: category, groupID: groupID }, // params (query)
        { deletedItemID: [groupID] } // data (body payload, just in case)
      );
      setUpdateTrigger(prev => prev + 1);
      await getPopulateFSNotes(category); // Refresh the UI
      if (subMenuId === groupID) {
        setSubMenuId(null);
      }
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const handleReorderSubGroup = async (category, fromIndex, toIndex) => {
    if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) return true;

    const previousRows = [...(fsNotesResponseData || [])];
    const reorderedRows = [...previousRows];
    const [moved] = reorderedRows.splice(fromIndex, 1);
    reorderedRows.splice(toIndex, 0, moved);

    setFsNotesResponseData(reorderedRows);

    try {
      const response = await rearrangeFSSectionApiHandler(
        { projectID: project_id, category: category },
        { fromIndex, toIndex }
      );

      if (response?.data?.success) {
        await getPopulateFSNotes(category);
        return true;
      }

      setFsNotesResponseData(previousRows);
      swal("Error", response?.data?.error || "Unable to reorder section", "error");
      return false;
    } catch (error) {
      setFsNotesResponseData(previousRows);
      console.error(error);
      swal("Error", error?.response?.data?.error || "Unable to reorder section", "error");
      return false;
    }
  };

  const handleAddSubGroup = async (category, name) => {
    try {
      const response = await addFSSectionApiHandler(
        { projectID: project_id, category: category },
        { name: name }
      );
      if (response?.data?.success) {
        setUpdateTrigger(prev => prev + 1);
        await getPopulateFSNotes(category);
        return true;
      } else if (response?.data?.error || response?.data?.message) {
        swal("Error", response.data.error || response.data.message, "error");
        return false;
      }
      return false;
    } catch (error) {
      console.error(error);
      swal("Error", error?.response?.data?.error || "name already exists", "error");
      return false;
    }
  };

  const handleEditSubGroup = async (category, groupID, name) => {
    try {
      const response = await updateFSSectionApiHandler(
        { projectID: project_id, category: category, groupID: groupID },
        { name: name }
      );
      if (response?.data?.success) {
        setUpdateTrigger(prev => prev + 1);
        await getPopulateFSNotes(category);
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return (
    <>
      <div className={`${workSpaceCss.df}`} style={{ height: "100vh", overflow: "hidden" }}>
        <div className={`d-flex ${commoncss.pageContent}`} style={{ height: "100%" }}>
          {!showBin && (
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 100, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              <FSSideMenu
                title="Financial Statements"
                menuItems={menuItems}
                subMenu={subMenu}
                activeCat={activeCat}
                setActiveCat={handleSetActiveCat}
                setSubMenuId={handleSetSubMenuId}
                showNotesDetails={showNotesDetails}
                redirectNote={redirectNote}
                setRedirectNote={setRedirectNote}
                subMenuId={subMenuId}
                isLoading={isLoading}
                resizable={true}
                project_id={project_id}
                onDeleteSubGroup={handleDeleteSubGroup}
                onAddSubGroup={handleAddSubGroup}
                onEditSubGroup={handleEditSubGroup}
                onReorderSubGroup={handleReorderSubGroup}
              />
            </motion.div>
          )}
          <div
            className={bookclosurecss.bookClosureContent}
            style={{ 
              width: showBin ? "100%" : "auto", 
              flex: 1,
              overflowX: "hidden",
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              height: "100%"
            }}
          >

           <div className={`${bookclosurecss.bookClosureHeader} p-0`} style={ showBin ? { position: "sticky", top: 0, zIndex: 10, backgroundColor: "transparent" } : {} }>
            <FSTopBar history={history} activeCat={activeCat} 
            showCashflowWorkings={showCashflowWorkings}
              onToggleCashflowWorkings={
                activeCat === "cashflow"
                  ? () => setShowCashflowWorkings((prev) => !prev)
                  : undefined
              }
               showAdjustmentLog={showAdjustmentLog}
               showAddAdjustment={showAddAdjustment} 
               onOpenAdjustmentLog={() => setShowAdjustmentLog(true)} 
               onBackFromAdjustmentLog={() => {
                  setShowAdjustmentLog(false);
                  setShowAddAdjustment(false);
                  refreshStandaloneCategoryData();
                }}
                onAddAdjustment={() => {
                  setShowAdjustmentLog(true);
                  setShowAddAdjustment(true);
                }}
                showBin={showBin}
                onOpenBin={() => {
                  const mapActiveCatToBinSection = (cat) => {
                    switch (cat) {
                      case "BS": return "Balance Sheet";
                      case "PL": return "P&L Statement";
                      case "general notes": return "General Notes";
                      case "BS notes": return "Balance Sheet Notes";
                      case "PL notes": return "P&L Statement Notes";
                      case "disclosure": return "Disclosures";
                      default: return "Balance Sheet";
                    }
                  };
                  setActiveBinSection(mapActiveCatToBinSection(activeCat));
                  setShowBin(true);
                }}
                onBackFromBin={() => {
                  setShowBin(false);
                  refreshStandaloneCategoryData();
                }}
                activeBinSection={activeBinSection}
                selectedBinCount={selectedBinItems.length}
                onDeletePermanently={handleDeletePermanently}
                onRestoreSelected={handleRestoreSelected}
                socieRows={rows}
                socieColumns={columns}
                onSocieConfigSaved={() => getPopulateFS("socie")}
             />
          </div>

            <div
              className={`${
                activeCat === "cashflow" && showCashflowWorkings
                  ? bookclosurecss.cashflowHideScroll   
                  : ""
              } ${bookclosurecss.tableLoadingWrapper} standalone-scroll-container`}
              style={{
                flex: 1,
                minHeight: 0,
                minWidth: 0,
                marginTop: showBin ? "3px" : "-15px",
                overflowY: showBin ? "hidden" : "auto",
                overflowX:
                  activeCat === "cashflow" && showCashflowWorkings
                    ? "auto"
                    : "hidden",
                padding: activeCat === "cashflow" && showCashflowWorkings ? "0px 0px 0px 0px" : "0px 15px 0px 20px",
                width:
                  activeCat === "cashflow" && showCashflowWorkings
                    ? "100%"
                    : activeCat === "socie"
                    ? "100%"
                    : "auto",
              }}
            >
              {isLoading && (
                <div className={bookclosurecss.tableLoaderOverlay}>
                  {activeCat === "cashflow" ? (
                    <Spinner animation="border" role="status" style={{ color: "#205a46" }} />
                  ) : (
                    <div className={bookclosurecss.tableLoaderDiv}>
                      <Spinner animation="grow" size="sm" />
                      <Spinner animation="grow" style={{ margin: "1rem" }} />
                      <Spinner animation="grow" size="sm" />
                    </div>
                  )}
                </div>
              )}
              {showBin ? (
                <StandaloneBin
                  project_id={project_id}
                  binSections={binSections}
                  activeBinSection={activeBinSection}
                  setActiveBinSection={setActiveBinSection}
                  activeBinTab={activeBinTab}
                  setActiveBinTab={setActiveBinTab}
                  deletedItems={deletedItems}
                  setDeletedItems={setDeletedItems}
                  selectedBinItems={selectedBinItems}
                  setSelectedBinItems={setSelectedBinItems}
                  renderSubGroups={renderSubGroups}
                  updateTrigger={updateTrigger}
                  onRestoreSuccess={() => setUpdateTrigger(prev => prev + 1)}
                />
              ) : activeCat === "cashflow" && showCashflowWorkings ? (
                <>
                  {showAdjustmentLog ? (
                      showAddAdjustment ? (
                        <AddNewAdjustment
                        projectID={project_id}
                        onBack={() => {
                          setShowAddAdjustment(false);
                          setShowAdjustmentLog(false);
                        }}/>
                      ) : (
                        <AdjustmentLog onAdd={() => setShowAddAdjustment(true)} />
                      )
                    ) : (
                     
                         <CashflowWorkings
                            groupingTemplateID={project_id}
                            cashflowWorkingsID={subMenuId}
                            dataID={subgroupId}
                            autoSave={true}
                            isStandalone={true}
                          />
      
                    )}
                  
                  {notesData && (
                    <div className="cashflow-custom-blocks">
                      {renderSubGroups(notesData)}
                    </div>
                  )}

                  {/* ── Text editor / add-table blocks — outside the table container ── */}
                  <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
                    <DragDropContext onDragEnd={onDragEndItems}>
                      <Droppable droppableId="standalone-bottom-items">
                        {(provided) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{ display: "grid", gap: 20 }}
                          >
                            {bottomBlocks.map((it, idx) => (
                              <Draggable key={it.id} draggableId={it.id} index={idx}>
                                {(dragProvided) => (
                                  <div
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    style={{
                                      ...dragProvided.draggableProps.style,
                                      width: "100%",
                                    }}
                                  >
                                    {it.type === "text" ? (
                                      <QuillReactEditor
                                        value={it.text?.[0]?.content ?? " "}
                                        onChange={(content) => {
                                          updateEditorContent(it.id, content);
                                        }}
                                        dragHandleProps={dragProvided.dragHandleProps}
                                        rightControl={null}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          border: "1px solid #ccd5d3",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                          background: "#fff",
                                          width: "100%",
                                        }}
                                      >
                                        <div
                                          style={{
                                            background: "#f8f9f9",
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 12px",
                                            borderBottom: "1px solid #ccd5d3",
                                            gap: "12px",
                                          }}
                                        >
                                          <div {...dragProvided.dragHandleProps} style={{ display: "flex", alignItems: "center" }}>
                                            <img src={MenuIcon} alt="drag" style={{ cursor: "grab", width: 9 }} />
                                          </div>
                                          <span
                                            style={{
                                              fontWeight: 600,
                                              fontSize: "13px",
                                              color: "#205a46",
                                              textTransform: "uppercase",
                                              flex: 1,
                                            }}
                                          >
                                            {it.tableTitle || "Table"}
                                          </span>
                                        </div>
                                       
                                      </div>
                                    )}
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>

                    <div
                      style={{
                        display: "flex",
                        gap: 12,
                        alignItems: "center",
                        padding: 12,
                        borderRadius: 12,
                        marginTop: 12,
                      }}
                    >
                      <CirclePlus width={37} />
                      <AddEditor width={140} onClick={handleAddParagraph} style={{ cursor: "pointer" }} />
                      <AddTable width={100} onClick={handleAddTableWithoutModal} style={{ cursor: "pointer" }} />
                    </div>

                    {isAddingTable && (
                      <div style={{ marginTop: "12px", position: "relative" }}>
                        {isSavingTable && (
                          <div style={{ position: "absolute", inset: 0, background: "rgba(255,255,255,0.7)", zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px" }}>
                            <div style={{ textAlign: "center" }}>
                              <Spinner animation="border" role="status" style={{ color: "#205a46", marginBottom: "10px" }} />
                              <div style={{ color: "#205a46", fontSize: "12px", fontWeight: 500 }}>Saving table...</div>
                            </div>
                          </div>
                        )}
                        <TemplateTableGenerator
                          isDisclosureTable={true}
                          forceOpen={true}
                          allowAddRow={true}
                          value={{
                            tableRow: [
                              { name: "", lineType: "" },
                              { name: "", lineType: "" },
                              { name: "", lineType: "" }
                            ]
                          }}
                          onChange={async (next) => {
                            if (isSavingTable) return;
                            const catToUse = "cashflowWorkings";
                            let activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;

                            if (!activeGroupId) {
                              const tempRes = await getPopulateFSDetailsApiHandler({ projectID: project_id, category: "cashflowWorkings" });
                              if (tempRes?.data?.success && tempRes?.data?.data?.length > 0) {
                                activeGroupId = tempRes.data.data[0]._id;
                              }
                            }

                            if (!activeGroupId) {
                              swal("Error", "No group ID found. Please try refreshing the page.", "error");
                              setIsAddingTable(false);
                              return;
                            }

                            try {
                              setIsSavingTable(true);
                              const params = {
                                projectID: project_id,
                                category: catToUse,
                                groupID: activeGroupId,
                              };

                              const tableColumn = (next.tableColumn || []).map((col) => ({
                                name: col.name || "",
                              }));

                              const finalColumns = tableColumn.length > 0
                                ? tableColumn
                                : [
                                    { name: "Particulars" },
                                    { name: "Current Year" },
                                    { name: "Previous Year" },
                                  ];

                              const payload = {
                                dataType: "table",
                                tableTitle: next.tableTitle || "New Table",
                                tableType: "default",
                                tableColumn: finalColumns,
                              };

                              const response = await addNotesSubgroupApiHandler(params, payload);
                              if (response?.data?.success) {
                                const newSubgroup = response.data.data;
                                
                                // If user has added data to cells, save it
                                const tableDataToSave = next.tableData || next.table || [];
                                if (tableDataToSave.length > 0) {
                                  const cleanRows = tableDataToSave.map(({ isNewRow, ...rest }) => rest);
                                  const updateParams = { ...params, subgroupID: newSubgroup._id || newSubgroup.id };
                                  const updatePayload = { table: cleanRows };
                                  const useReplaceApi = ["BS notes", "PL notes", "general notes", "disclosure", "cashflowWorkings"].includes(catToUse);
                                  if (useReplaceApi) {
                                    await replaceNotesTableApiHandler(updateParams, updatePayload);
                                  } else {
                                    await updatePopulateFSApiHandler(updateParams, updatePayload);
                                  }
                                }
                                
                                await getPopulateFSNotes(catToUse);
                                setIsAddingTable(false);
                                swal({
                                  title: "Success",
                                  text: "Table added successfully. Click on cells to edit.",
                                  icon: "success",
                                  button: "OK",
                                  timer: 2000
                                });
                              } else {
                                swal("Error", response?.data?.message || "Failed to save table", "error");
                              }
                            } catch (err) {
                              console.error("Error adding table:", err?.response || err);
                              const errorMsg = err?.response?.data?.message || "Failed to add table. Please try again.";
                              swal("Error", errorMsg, "error");
                            } finally {
                              setIsSavingTable(false);
                            }
                          }}
                          onCancel={() => {
                            if (!isSavingTable) setIsAddingTable(false);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </>
              ) : (
            <>
              {!isNotes && activeCat !== "checklist" && (
                <div className={activeCat === "socie" ? "socie-table-wrapper" : ""} style={activeCat === "socie" ? { paddingBottom: "10px" } : {}}>
                  <ShowDetails />
                </div>
              )}
            </>
          )}
              {isNotes && notesData && activeCat !== "checklist" && !showBin && (
                <>
                  {renderSubGroups(notesData)}
                </>
              )}

              {isNotes && subMenuId && activeCat === "checklist" && !showBin && (
                <ShowChecklist subMenuId={subMenuId} />
              )}
              
              {(
                ["BS notes", "PL notes", "general notes", "disclosure"].includes(activeCat) && !showBin
              ) && (
                <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
                  <DragDropContext onDragEnd={onDragEndItems}>
                    <Droppable droppableId="standalone-bottom-items">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={{ display: "grid", gap: 20 }}
                        >
                          {bottomBlocks.map((it, idx) => (
                            <Draggable key={it.id} draggableId={it.id} index={idx}>
                              {(dragProvided) => (
                                <div
                                  ref={dragProvided.innerRef}
                                  {...dragProvided.draggableProps}
                                  style={{
                                    ...dragProvided.draggableProps.style,
                                    width: "100%",
                                  }}
                                >
                                  {it.type === "text" ? (
                                    <QuillReactEditor
                                      value={it.text?.[0]?.content ?? " "}
                                      onChange={(content) => {
                                        updateEditorContent(it.id, content);
                                      }}
                                      dragHandleProps={dragProvided.dragHandleProps}
                                      rightControl={null}
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        border: "1px solid #e3efe7",
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        background: "#fff",
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          background: "#f8f9f9",
                                          display: "flex",
                                          alignItems: "center",
                                          padding: "10px 12px",
                                          borderBottom: "1px solid #e3efe7",
                                          gap: "12px",
                                        }}
                                      >
                                        <div {...dragProvided.dragHandleProps} style={{ display: "flex", alignItems: "center" }}>
                                          <img src={MenuIcon} alt="drag" style={{ cursor: "grab", width: 9 }} />
                                        </div>
                                        <span
                                          style={{
                                            fontWeight: 600,
                                            fontSize: "13px",
                                            color: "#205a46",
                                            textTransform: "uppercase",
                                            flex: 1,
                                          }}
                                        >
                                          {it.tableTitle || "Table"}
                                        </span>
                                        {it.isTemp && (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "6px",
                                              cursor: "pointer",
                                              color: "#1d935e",
                                              fontWeight: 600,
                                              fontSize: "13px",
                                            }}
                                            onClick={() => {
                                              saveTableToApi(it.id, it);
                                            }}
                                          >
                                            <span className="material-symbols-outlined" style={{ fontSize: "22px" }}></span>
                                            Add
                                          </div>
                                        )}
                                        {true && (
                                            <DelIcon
                                              style={{ cursor: "pointer", width: 16, height: 16 }}
                                              onClick={() => {
                                                swal({
                                                  title: "Are you sure?",
                                                  text: "You want to delete this block?",
                                                  icon: "warning",
                                                  buttons: true,
                                                  dangerMode: true,
                                                }).then((willDelete) => {
                                                  if (willDelete) {
                                                    removeItem(it.id);
                                                    if (it.subgroupID) {
                                                      deletePopulateFS(it.subgroupID);
                                                    }
                                                  }
                                                });
                                              }}
                                            />
                                          )}
                                      </div>

                                      <div
                                        style={{
                                          background: "#fff",
                                          padding: 0,
                                        }}
                                      >
                                        <TemplateTableGenerator
                                          isDisclosureTable={true}
                                          tableId={it.id}
                                          forceOpen={it.isTemp ? it.forceOpen : it.id === forceOpenTableId}
                                          value={{
                                            tableTitle: it.tableTitle,
                                            tableRow: it.tableRow,
                                            tableColumn: it.tableColumn,
                                            tableType: it.tableType,
                                            table: getStandaloneTableRowsForSave(it.table),
                                            hasCellData: ["BS notes", "PL notes"].includes(activeCat) ? true : it.hasCellData,
                                          }}
                                          onChange={(next) => {
                                            const previousRows = it.tableData || it.table || [];
                                            const nextRows = next.tableData || [];
                                            if (
                                              nextRows.length > previousRows.length &&
                                              isStandaloneBlankRow(nextRows[nextRows.length - 1])
                                            ) {
                                              skipStandaloneTableSaveOnceRef.current[it.id] = true;
                                            }
                                            updateTableItem(it.id, {
                                              tableTitle: next.tableTitle,
                                              tableRow: next.tableRow || it.tableRow,
                                              tableColumn: next.tableColumn,
                                              hasCellData: next.hasCellData,
                                              tableData: next.tableData,
                                              tableType: next.tableType,
                                            });
                                          }}
                                          onAfterOpen={() => {
                                            if (it.isTemp) {
                                              setBottomBlocks((prev) =>
                                                prev.map((block) =>
                                                  block.id === it.id
                                                    ? { ...block, forceOpen: false }
                                                    : block
                                                )
                                              );
                                            } else if (forceOpenTableId === it.id) {
                                              setForceOpenTableId(null);
                                            }
                                          }}
                                          onCellBlur={() => {
                                            queueStandaloneTableSave(it.id);
                                          }}
                                          onSaveStructure={(next) => {
                                            queueStandaloneTableSave(it.id);
                                          }}
                                          onCancel={() => {
                                            if (it.isTemp) {
                                              removeItem(it.id);
                                            }
                                          }}
                                          hideHeader={true}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>

                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      alignItems: "center",
                      padding: 12,
                      borderRadius: 12,
                      marginTop: 12,
                    }}
                  >
                    <CirclePlus width={37} />
                    <AddEditor width={140} onClick={handleAddParagraph} style={{ cursor: "pointer" }} />
                    <AddTable width={100} onClick={handleAddTableWithoutModal} style={{ cursor: "pointer" }} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      
      <SuccessPopup
        isOpen={showSuccessPopup}
        onClose={() => setShowSuccessPopup(false)}
        message={successMessage}
      />
      <DeletePopup
        isOpen={deleteConfirm !== null}
        title={deleteConfirm?.title}
        message={deleteConfirm?.message}
        onConfirm={deleteConfirm?.onConfirm}
        onCancel={() => setDeleteConfirm(null)}
      />
      <RestorePopup
        isOpen={restoreConfirm !== null}
        title={restoreConfirm?.title}
        message={restoreConfirm?.message}
        onConfirm={restoreConfirm?.onConfirm}
        onCancel={() => setRestoreConfirm(null)}
      />
      
      <SidePanel
        showLinkPanel={showLinkPanel}
        setShowLinkPanel={setShowLinkPanel}
        table={
          activeCat === "socie"
            ? { cellFormulas: getAllCellFormulas(loadData) }
            : activeCat === "disclosure"
            ? {
                cellFormulas:
                  (fsNotesResponseData || [])
                    .flatMap((g) => g.subgroup || g.subGroup || [])
                    .find((sg) => String(sg._id || sg.id) === String(panelDataID))?.cellFormulas || [],
              }
            : undefined
        }
        activeCellKey={activeCellKey}
        selectedCell={selectedCell}
        type={activeCat === "disclosure" ? "disclosure" : activeCat === "socie" ? "socie" : activeCat}
        groupingTemplateID={project_id}
        dataID={panelDataID}
        disclosureID={subMenuId || fsNotesResponseData?.[0]?._id}
        isTemplate={false}
        onApply={async (body, freshData) => {
          await refreshStandaloneCategoryData();
        }}
      />
    </>
  );
};

export default StandaloneFinancialStatement;
